
<template>
  <div class="personal-center-modular">
    <div class="user-info-header">
      <img class="header-bg" src="../assets/myOrder/header-bg.png" alt="" />
      <div class="header-absolute-modular">
        <div class="user-info-item">
          <div class="left-item">
            <div class="face-item">
              <img class="user-face" :src="userInfoForm.head_img" alt="" />
            </div>
            <div class="info-item">
              <div class="user-name">{{ userInfoForm.userName }}</div>
              <div class="user-email">{{ userInfoForm.email }}</div>
              <div class="user-company">{{ userInfoForm.company }}</div>
            </div>
          </div>
          <div class="right-item">
            <el-button class="edit-btn" @click="toEditUsrtInfo(6)">{{
              pageTextArr[0]
            }}</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="personal-center-body">
      <div class="personal-center-body-modualr">
        <el-row :gutter="20">
          <el-col :span="4" :xs="24">
            <div class="menu-modular">
              <div class="menu-header">
                <div class="menu-header-title">
                  {{ pageTextArr[1] }}
                </div>
              </div>
              <div class="menu-item-list-menu">
                <div
                  class="menu-item"
                  v-for="(item, index) in menuList"
                  :key="index"
                  @click="clickMenu(index)"
                >
                  <img
                    class="menu-item-icon"
                    :src="item.flag ? item.icon2 : item.icon1"
                    alt=""
                  />
                  <span
                    :class="
                      item.flag
                        ? 'menu-item-title-active menu-item-title'
                        : 'menu-item-title'
                    "
                    >{{ item.title }}</span
                  >
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="20" :xs="24">
            <!-- 我的订单 -->
            <div class="view-modular" v-if="menuActiveIndex == 0">
              <div class="my-order-modualr" v-if="showOrder">
                <el-row :gutter="20">
                  <el-col :span="18" :xs="24">
                    <div class="header-menu">
                      <div
                        :class="
                          orderMenuActive == index
                            ? 'menu-item menu-item-active'
                            : 'menu-item'
                        "
                        v-for="(item, index) in orderMenu"
                        :key="index"
                        @click="orderMenuClick(item.index, index)"
                      >
                        <span v-if="item.num == 0" class="menu-item-title">{{
                          item.title
                        }}</span>
                        <el-badge :value="item.num" class="item" v-else>
                          <span class="menu-item-title">{{ item.title }}</span>
                        </el-badge>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="6" :xs="24">
                    <div class="search-header-modualr">
                      <el-input
                        class="search-input"
                        size="medium"
                        :placeholder="pageTextArr[15]"
                        suffix-icon="el-icon-search"
                        v-model="searchKey"
                        @keyup.enter.native="getUserOrderList()"
                      >
                      </el-input>
                    </div>
                  </el-col>
                </el-row>
                <div class="order-info-table-theader">
                  <el-row :gutter="10">
                    <el-col :span="9">
                      <div class="theader-title theader-first-title">
                        {{ pageTextArr[16] }}
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div class="theader-title">
                        {{ pageTextArr[17] }}
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div class="theader-title">
                        {{ pageTextArr[18] }}
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div class="theader-title">
                        {{ pageTextArr[19] }}
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div class="theader-title">
                        {{ pageTextArr[20] }}
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div class="theader-title">
                        {{ pageTextArr[21] }}
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div
                  class="order-info-table-tbody"
                  :class="(index==0?'':'order-info-table-tbody-line')"
                  v-loading="orderListloading"
                >
                  <div
                    v-if="orderList.length == 0"
                    class="my-evaluate-bodu-none-center"
                  >
                    <img
                      class="none-icon"
                      src="../assets/public/none-icon.png"
                      alt=""
                    />
                    <p class="none-title">{{ pageTextArr[23] }}~</p>
                  </div>
                  <div
                    v-else
                    class="order-info-item"
                    v-for="(item, index) in orderList"
                    :key="index"
                  >
                    <div class="order-info-item-header">
                      <div class="order-info-item-header-left">
                        <span>{{ item.create_time }}</span>
                        <span class="order-number">{{
                          pageTextArr[22] + "：" + item.order_number
                        }}</span>
                      </div>
                      <!-- :icon="el - icon - info" -->
                      <div class="order-info-item-header-right">
                        <el-popconfirm
                          :confirm-button-text="pageTextArr[34]"
                          :cancel-button-text="pageTextArr[35]"
                          icon-color="red"
                          :title="pageTextArr[36]"
                          @confirm="deleteUserOrder(item.id)"
                        >
                          <img
                            class="delete-icon"
                            slot="reference"
                            src="../assets/myOrder/delete-icon.png"
                            alt=""
                          />
                        </el-popconfirm>
                        <!-- <img class="delete-icon" src="../assets/myOrder/delete-icon.png" @click="deleteUserOrder(item.id)"
                                alt=""> -->
                      </div>
                    </div>
                    <!-- 组合商品 -->
                    <div
                      class="order-info-item-body"
                      v-for="(item2, index2) in item.portfolio_sales_data"
                      :key="index2"
                    >
                      <el-row
                        :gutter="10"
                        v-for="(item2_1, index2_1) in item2"
                        :key="index2_1"
                      >
                        <el-col :span="9" :xs="24">
                          <div class="commodity-info-item">
                            <div class="img-item">
                              <img
                                class="commodity-img"
                                @click="toProductDetail(item2_1.id)"
                                :src="item2_1.cover"
                                alt=""
                              />
                            </div>
                            <div class="detail-item">
                              <div class="commodity-info-item">
                                {{
                                  currLanguage == 3
                                    ? item2_1.eng_title
                                    : item2_1.title
                                }}
                              </div>
                              <div class="commodity-voltage-item">
                                {{
                                  currLanguage == 3
                                    ? item2_1.eng_specifications
                                    : item2_1.specifications
                                }}
                              </div>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="3" :xs="8">
                          <div class="commodity-unit-price-item">
                            {{ currencySymbol }}{{ item2_1.price }}
                          </div>
                        </el-col>
                        <el-col :span="3" :xs="8">
                          <div class="commodity-number-item">
                            {{ item2_1.amount }}
                          </div>
                        </el-col>
                        <el-col :span="3" :xs="8">
                          <div
                            class="commodity-actual-payment-item"
                            v-if="index2 == 0 && index2_1 == 0"
                          >
                            {{ currencySymbol }}{{ item.endprice }}
                          </div>
                          <div
                            class="commodity-actual-payment-item"
                            v-else
                          ></div>
                        </el-col>
                        <el-col :span="3" :xs="12">
                          <div
                            class="commodity-transaction-state-item"
                            v-if="index2 == 0 && index2_1 == 0"
                          >
                            <div class="order-state-item">
                              <!-- 1->下单，待付款 -->
                              <div
                                class="order-state-1"
                                v-if="item.status == 1"
                              >
                                {{ pageTextArr[22] }}
                              </div>
                              <!-- 2->下单，已付款，待审核，3->下单，已付款 -->
                              <div
                                class="order-state-2"
                                v-else-if="item.status == 2 || item.status == 3"
                              >
                                {{ pageTextArr[23] }}
                              </div>
                              <!-- 4->下单，已发货，未签收 -->
                              <div
                                class="order-state-3"
                                v-else-if="item.status == 4"
                              >
                                {{ pageTextArr[24] }}
                              </div>
                              <!-- 5->下单，已发货，已签收，待评价 -->
                              <div
                                class="order-state-4"
                                v-else-if="item.status == 5"
                              >
                                {{ pageTextArr[25] }}
                              </div>
                              <!-- 6->下单，已发货，拒收 -->
                              <!-- 7->下单，已发货，已评价，结束; | -->
                            </div>
                            <div
                              class="order-detail-title"
                              @click="toPayment(item.order_number, item.id)"
                            >
                              {{ pageTextArr[26] }}
                            </div>
                            <!-- <div class="order-logistics-title" v-show="item.status == 4">
                                                                <el-popover placement="left" width="550" trigger="click" v-if="equipmentType == 0">
                                                                  <div class="order-logistics-popover">
                                                                    <div class="order-logistics-popover-header">
                                                                      <div class="order-logistics-popover-header-left">
                                                                        <span class="logisticsName">{{ logisticsData.logisticsName }}</span>
                                                                        <span class="courierNumber">快递单号：{{ logisticsData.courierNumber }}</span>
                                                                      </div>
                                                                      <div class="order-logistics-popover-header-right">
                                                                        更多>
                                                                      </div>
                                                                    </div>
                                                                    <div class="order-logistics-popover-body">
                                                                      <el-timeline>
                                                                        <el-timeline-item v-for="(activity, index) in logisticsData.timelineData"
                                                                          :key="index" :icon="activity.icon" :type="activity.type" :color="activity.color"
                                                                          :size="activity.size" :timestamp="activity.timestamp" placement="top">
                                                                          <h4 v-if="activity.content != null">{{ activity.content }}</h4>
                                                                          <p v-if="activity.info != null">{{ activity.info }}</p>
                                                                        </el-timeline-item>
                                                                      </el-timeline>
                                                                    </div>
                                                                  </div>
                                                                  <el-button slot="reference" class="view-order-logistics-btn">查看物流</el-button>
                                                                </el-popover>
                                                                <el-button v-else class="view-order-logistics-btn" @click="showlogistics()">查看物流</el-button>
                                                                    </div> -->
                          </div>
                          <div class="commodity-transaction-state-item" v-else>
                            <span
                              style="display: inline-block; width: 100%"
                            ></span>
                          </div>
                        </el-col>
                        <el-col :span="3" :xs="12">
                          <div
                            class="operation-item"
                            v-if="index2 == 0 && index2_1 == 0"
                          >
                            <div
                              v-if="item.status == 1"
                              class="commodity-paymentStatus-1"
                            >
                              <!-- 付款 -->
                              <el-button
                                class="payment-btn"
                                @click="toPayment(item.order_number, item.id)"
                                >{{ pageTextArr[28] }}</el-button
                              >
                              <div
                                class="cancel-order-title"
                                @click="dealOrder(item.id, -1)"
                              >
                                {{ pageTextArr[29] }}
                              </div>
                            </div>
                            <div
                              v-else-if="item.status == 2"
                              class="commodity-paymentStatus-2"
                            >
                              <div
                                class="cancel-order-title"
                                @click="dealOrder(item.id, -1)"
                              >
                                {{ pageTextArr[29] }}
                              </div>
                            </div>
                            <div
                              v-else-if="item.status == 3 || item.status == 4"
                              class="commodity-paymentStatus-3"
                            >
                              <el-button
                                class="confirm-receipt-btn"
                                @click="dealOrder(item.id, 5)"
                                >{{ pageTextArr[30] }}</el-button
                              >
                            </div>
                            <div
                              v-else-if="item.status == 5"
                              class="commodity-paymentStatus-4"
                            >
                              <el-button
                                class="evaluate-btn"
                                @click="
                                  appraiseProductHandler(
                                    item.id,
                                    item.portfolio_sales_data,
                                    item.product_data
                                  )
                                "
                                >{{ pageTextArr[31] }}</el-button
                              >
                            </div>
                          </div>
                          <!-- <div class="operation-item" v-else>
                            <div
                              v-if="item.status == 5"
                              class="commodity-paymentStatus-4"
                            >
                              <el-button class="evaluate-btn" @click="appraiseProductHandler(item.id,item.portfolio_sales_data)">评价</el-button>
                            </div>
                                </div> -->
                        </el-col>
                      </el-row>
                    </div>
                    <!-- 单个商品 -->
                    <div
                      class="order-info-item-body"
                      v-for="(item3, index3) in item.product_data"
                      :key="index3"
                    >
                      <el-row :gutter="10">
                        <el-col :span="9" :xs="24">
                          <div class="commodity-info-item">
                            <div class="img-item">
                              <img
                                class="commodity-img"
                                @click="toProductDetail(item.id)"
                                :src="item3.cover"
                                alt=""
                              />
                            </div>
                            <div class="detail-item">
                              <div class="commodity-info-item">
                                {{ item3.title }}
                              </div>
                              <div class="commodity-voltage-item">
                                {{ item3.specifications }}
                              </div>
                            </div>
                          </div>
                        </el-col>
                        <el-col :span="3" :xs="8">
                          <div class="commodity-unit-price-item">
                            {{ currencySymbol }}{{ item3.price }}
                          </div>
                        </el-col>
                        <el-col :span="3" :xs="8">
                          <div class="commodity-number-item">
                            {{ item3.amount }}
                          </div>
                        </el-col>
                        <el-col :span="3" :xs="8">
                          <div class="commodity-actual-payment-item">
                            <span
                              v-if="
                                item.portfolio_sales_data.length > 0
                                  ? false
                                  : index3 == 0
                              "
                              >{{ currencySymbol }}{{ item.endprice }}</span
                            >
                          </div>
                        </el-col>
                        <el-col :span="3" :xs="12">
                          <div
                            class="commodity-transaction-state-item"
                            v-if="
                              item.portfolio_sales_data.length > 0
                                ? false
                                : index3 == 0
                            "
                          >
                            <div class="order-state-item">
                              <!-- 1->下单，待付款 -->
                              <div
                                class="order-state-1"
                                v-if="item.status == 1"
                              >
                                {{ pageTextArr[24] }}
                              </div>
                              <!-- 2->下单，已付款，待审核，3->下单，已付款 -->
                              <div
                                class="order-state-2"
                                v-else-if="item.status == 2 || item.status == 3"
                              >
                                {{ pageTextArr[25] }}
                              </div>
                              <!-- 4->下单，已发货，未签收 -->
                              <div
                                class="order-state-3"
                                v-else-if="item.status == 4"
                              >
                                {{ pageTextArr[26] }}
                              </div>
                              <!-- 5->下单，已发货，已签收，待评价 -->
                              <div
                                class="order-state-4"
                                v-else-if="item.status == 5"
                              >
                                {{ pageTextArr[27] }}
                              </div>
                              <!-- 6->下单，已发货，拒收 -->
                              <!-- 7->下单，已发货，已评价，结束; | -->
                            </div>
                            <div
                              class="order-detail-title"
                              @click="toPayment(item.order_number, item.id)"
                            >
                              {{ pageTextArr[37] }}
                            </div>
                            <!-- <div class="order-logistics-title" v-show="item.status == 4">
                                <el-popover placement="left" width="550" trigger="click" v-if="equipmentType == 0">
                                  <div class="order-logistics-popover">
                                    <div class="order-logistics-popover-header">
                                      <div class="order-logistics-popover-header-left">
                                        <span class="logisticsName">{{ logisticsData.logisticsName }}</span>
                                        <span class="courierNumber">快递单号：{{ logisticsData.courierNumber }}</span>
                                      </div>
                                      <div class="order-logistics-popover-header-right">
                                        更多>
                                      </div>
                                    </div>
                                    <div class="order-logistics-popover-body">
                                      <el-timeline>
                                        <el-timeline-item v-for="(activity, index) in logisticsData.timelineData"
                                          :key="index" :icon="activity.icon" :type="activity.type" :color="activity.color"
                                          :size="activity.size" :timestamp="activity.timestamp" placement="top">
                                          <h4 v-if="activity.content != null">{{ activity.content }}</h4>
                                          <p v-if="activity.info != null">{{ activity.info }}</p>
                                        </el-timeline-item>
                                      </el-timeline>
                                    </div>
                                  </div>
                                  <el-button slot="reference" class="view-order-logistics-btn">查看物流</el-button>
                                </el-popover>
                                <el-button v-else class="view-order-logistics-btn" @click="showlogistics()">查看物流</el-button>
                                    </div> -->
                          </div>
                        </el-col>
                        <el-col :span="3" :xs="12">
                          <div
                            class="operation-item"
                            v-if="
                              item.portfolio_sales_data.length > 0
                                ? false
                                : index3 == 0
                            "
                          >
                            <div
                              v-if="item.status == 1"
                              class="commodity-paymentStatus-1"
                            >
                              <!-- 付款 -->
                              <el-button
                                class="payment-btn"
                                @click="toPayment(item.order_number, item.id)"
                                >{{ pageTextArr[28] }}</el-button
                              >
                              <div
                                class="cancel-order-title"
                                @click="dealOrder(item.id, -1)"
                              >
                                {{ pageTextArr[29] }}
                              </div>
                            </div>
                            <div
                              v-else-if="item.status == 2"
                              class="commodity-paymentStatus-2"
                            >
                              <div
                                class="cancel-order-title"
                                @click="dealOrder(item.id, -1)"
                              >
                                {{ pageTextArr[29] }}
                              </div>
                            </div>
                            <!-- <div
                              v-else-if="item.status == 3"
                              class="commodity-paymentStatus-2"
                                  ></div> -->
                            <div
                              v-else-if="item.status == 4"
                              class="commodity-paymentStatus-3"
                            >
                              <el-button
                                class="confirm-receipt-btn"
                                @click="dealOrder(item.id, 5)"
                              >
                                {{
                                  $t("translateText.confirmreceiptText")
                                }}</el-button
                              >
                            </div>
                            <div
                              v-else-if="item.status == 5"
                              class="commodity-paymentStatus-4"
                            >
                              <el-button
                                class="evaluate-btn"
                                @click="
                                  appraiseProductHandler(
                                    item.id,
                                    item.portfolio_sales_data,
                                    item.product_data
                                  )
                                "
                                >{{ pageTextArr[31] }}</el-button
                              >
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
                <div class="pagination-footer-modualr">
                  <el-pagination
                    :pager-count="11"
                    background
                    layout="prev, pager, next"
                    :total="pageCount"
                    @current-change="handleCurrentChange"
                  >
                  </el-pagination>
                </div>
              </div>
              <div v-else>
                <!-- 评价星级 评价内容 评价图片 多张 逗号隔开 -->
                <div v-for="(itemList, i) in appraiseProduct" :key="i">
                  <div
                    class="apprais-product-modualr"
                    v-for="(proItem, proIndex) in itemList"
                    :key="proIndex"
                  >
                    <div class="product-detail">
                      <div class="product-img">
                        <img :src="proItem.cover" alt="" />
                      </div>
                      <div class="detail-item">
                        <div class="commodity-info-item">
                          {{ proItem.title }}
                        </div>
                        <div class="commodity-voltage-item">
                          {{ proItem.specifications }}
                        </div>
                      </div>
                    </div>
                    <div class="right-product-content">
                      <div class="evaluate-stars-modualr-title">
                        <van-rate
                          v-model="proItem.star"
                          :size="25"
                          color="#ff7a4d"
                          void-icon="star"
                          void-color="#eee"
                          @change="onStarChange(i, proIndex)"
                        />
                      </div>
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 5, maxRows: 20 }"
                        placeholder="请输入内容"
                        v-model="proItem.appraiseText"
                        @input="inputValue"
                        @focus="inputSelectedIndex(i, proIndex)"
                        maxlength="500"
                        show-word-limit
                      >
                      </el-input>
                      <div class="upload-img-modualr">
                        <div
                          v-for="(item, index) in proItem.appraiseImgList"
                          :key="index"
                          class="upload-img-item-modular"
                        >
                          <img class="upload-img-item" :src="item" alt="" />
                          <i
                            class="el-icon-circle-close"
                            @click="deleteImg(proItem.appraiseImgList, index)"
                          ></i>
                        </div>
                        <div @click="uploadImgList(i, proIndex, 2)">
                          <el-upload
                            class="avatar-uploader"
                            :action="uploadUrl"
                            list-type="picture-card"
                            :headers="headerData"
                            :before-upload="beforeFileUpload"
                            :on-success="uploadappraiseImgSeccess"
                            :show-file-list="false"
                          >
                            <i class="el-icon-plus"></i>
                          </el-upload>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 单个商品-->
                <div
                  class="apprais-product-modualr"
                  v-for="(proItem, proIndex) in appraiseoneProduct"
                  :key="proIndex"
                >
                  <div class="product-detail">
                    <div class="product-img">
                      <img :src="proItem.cover" alt="" />
                    </div>
                    <div class="detail-item">
                      <div class="commodity-info-item">
                        {{ proItem.title }}
                      </div>
                      <div class="commodity-voltage-item">
                        {{ proItem.specifications }}
                      </div>
                    </div>
                  </div>
                  <div class="right-product-content">
                    <div class="evaluate-stars-modualr-title">
                      <van-rate
                        v-model="proItem.star"
                        :size="25"
                        color="#ff7a4d"
                        void-icon="star"
                        void-color="#eee"
                        allow-hall
                        @change="onfirstStarChange(proIndex)"
                      />
                    </div>
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 5, maxRows: 20 }"
                      placeholder="请输入内容"
                      v-model="proItem.appraiseText"
                      @input="firstinputValue"
                      @focus="firstinputSelectedIndex(proIndex)"
                      maxlength="500"
                      show-word-limit
                    >
                    </el-input>
                    <div class="upload-img-modualr">
                      <div
                        class="upload-img-item-modular"
                        v-for="(item, index) in proItem.appraiseImgList"
                        :key="index"
                      >
                        <img class="upload-img-item" :src="item" alt="" />
                        <i
                          class="el-icon-circle-close"
                          @click="deleteImg(proItem.appraiseImgList, index)"
                        ></i>
                      </div>
                      <div @click="uploadImgList(proIndex, index, 1)">
                        <el-upload
                          class="avatar-uploader"
                          :action="uploadUrl"
                          list-type="picture-card"
                          :headers="headerData"
                          :before-upload="beforeFileUpload"
                          :on-success="uploadappraiseImgSeccess"
                          :show-file-list="false"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="btn-modular">
                  <el-button class="add-address-btn" @click="cancelApprais"
                    >取消
                    <!-- {{ $t("translateText.addseliveryaddressText") }} -->
                  </el-button>
                  <el-button
                    class="add-address-btn1"
                    @click="appraisProductContentList"
                    >提交
                    <!-- {{ $t("translateText.addseliveryaddressText") }} -->
                  </el-button>
                </div>
              </div>
            </div>

            <!-- 我的评价 -->
            <div v-else-if="menuActiveIndex == 1" class="my-evaluate-modualr">
              <div class="my-evaluate-header-modualr">
                <div
                  :class="
                    index == evaluateHeaderBar.activeBar
                      ? 'evaluate-header-item active-evaluate-item'
                      : 'evaluate-header-item'
                  "
                  v-for="(item, index) in evaluateHeaderBar.barList"
                  :key="index"
                  @click="clickEvaluateHeaderBar(index)"
                >
                  {{ currLanguage == 3 ? item.eng_title : item.title }}
                </div>
              </div>

              <div class="my-evaluate-body-modualr">
                <div
                  v-if="
                    evaluateHeaderBar.activeBar == 0 && evaluateData.length == 0
                  "
                  class="my-evaluate-bodu-none"
                >
                  <img
                    class="none-icon"
                    src="../assets/public/none-icon.png"
                    alt=""
                  />
                  <p class="none-title">{{ pageTextArr[23] }}~</p>
                </div>
                <!-- 产品 -->
                <div v-else>
                  <div
                    class="my-evaluate-body-product-modualr"
                    v-if="evaluateHeaderBar.activeBar == 0"
                  >
                    <div class="my-evaluate-body-product-theader">
                      <el-row :gutter="20">
                        <el-col :span="12" :xs="24">
                          <div class="my-evaluate-body-product-theader-title">
                            {{ pageTextArr[38] }}
                          </div>
                        </el-col>
                        <el-col :span="12" :xs="24">
                          <div
                            class="my-evaluate-body-product-theader-title"
                            style="border-left: 1px solid #dddddd"
                          >
                            {{ pageTextArr[40] }}
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                    <div class="my-evaluate-body-product-tbody">
                      <div
                        class="my-evaluate-body-product-item"
                        v-for="(item, index) in evaluateData"
                        :key="index"
                      >
                        <el-row :gutter="20">
                          <el-col :span="12" :xs="24">
                            <div class="my-evaluate-body-product-tbody-left">
                              <div class="img-item">
                                <img
                                  class="product-img"
                                  @click="toProductDetail(item.product_id)"
                                  :src="item.cover"
                                  alt=""
                                />
                              </div>
                              <div class="info-item">
                                <div class="info-title">
                                  {{
                                    currLanguage == 3
                                      ? item.eng_title
                                      : item.title
                                  }}
                                </div>
                                <div class="voltage-title">
                                  {{
                                    currLanguage == 3 ? item.eng_spe : item.spe
                                  }}
                                </div>
                              </div>
                            </div>
                          </el-col>
                          <el-col :span="12" :xs="24">
                            <div class="my-evaluate-body-product-tbody-right">
                              <div class="evaluate-stars-modualr-title">
                                <van-rate
                                  v-model="item.star"
                                  :size="14"
                                  color="#ff7a4d"
                                  void-icon="star"
                                  void-color="#eee"
                                />
                              </div>
                              <div class="my-evaluate-title">
                                {{ item.comment }}
                              </div>
                              <div v-if="item.pics">
                                <img
                                  class="my-evaluate-img"
                                  :src="item2"
                                  v-for="(item2, index2) in item.pics.split(
                                    ','
                                  )"
                                  :key="index2"
                                />
                              </div>
                              <div class="my-evaluate-date">
                                {{ item.create_time }}
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </div>
                  <!-- 产品分页 -->
                  <div
                    class="pagination-footer-modualr"
                    v-if="evaluateHeaderBar.activeBar == 0"
                  >
                    <el-pagination
                      :pager-count="11"
                      :page-size="pagesize"
                      background
                      layout="prev, pager, next"
                      :total="pageCount"
                      @current-change="handleCurrentChange"
                    >
                    </el-pagination>
                  </div>
                </div>

                <!-- 博客 -->
                <div
                  class="my-evaluate-body-blog-modualr"
                  v-if="evaluateHeaderBar.activeBar == 1"
                >
                  <div
                    v-if="
                      evaluateHeaderBar.activeBar == 1 &&
                      blogListData.length == 0
                    "
                    class="my-evaluate-bodu-none"
                  >
                    <img
                      class="none-icon"
                      src="../assets/public/none-icon.png"
                      alt=""
                    />
                    <p class="none-title">
                      {{ pageTextArr[23] }}
                    </p>
                  </div>
                  <div v-else>
                    <div
                      class="my-evaluat-blog-item"
                      v-for="(item, index) in blogListData"
                      :key="index"
                      @click="toBolgDeatil(item.blog_id)"
                    >
                      <div class="my-evaluat-blog-item-time">
                        {{ item.create_time }}
                      </div>
                      <div class="my-evaluat-blog-item-title">
                        {{ item.content }}
                      </div>
                      <div class="my-evaluat-blog-item-reply">
                        <span>{{ $t("translateText.replyblogText") }}</span>
                        <span>{{ item.title }}</span>
                      </div>
                    </div>
                    <!-- 博客分页 -->
                    <div
                      class="pagination-footer-modualr"
                      v-if="evaluateHeaderBar.activeBar == 1"
                    >
                      <el-pagination
                        :pager-count="11"
                        background
                        layout="prev, pager, next"
                        :total="pageCount"
                        @current-change="handleCurrentChange"
                      >
                      </el-pagination>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 我的收藏 -->
            <div v-else-if="menuActiveIndex == 2" class="my-collection-modualr">
              <div class="my-collection-header">
                <el-input
                  :placeholder="pageTextArr[41]"
                  class="search-product-input"
                  suffix-icon="el-icon-search"
                  v-model="collectionSearchKey"
                  @keyup.enter.native="getUserProductCollectList()"
                >
                </el-input>
              </div>
              <div
                v-if="ProductCollectList.length == 0"
                class="my-collection-none"
              >
                <img
                  class="none-icon"
                  src="../assets/public/none-icon.png"
                  alt=""
                />
                <p class="none-title">{{ pageTextArr[23] }}</p>
              </div>
              <div class="my-collection-body" v-else>
                <el-row :gutter="15" style="width: 98%; margin: auto">
                  <el-col
                    :span="6"
                    :xs="24"
                    v-for="(item, index) in ProductCollectList"
                    :key="index"
                  >
                    <div class="commodity-show-item-modualr">
                      <div class="commodity-show-item">
                        <div class="commodity-show-item-img">
                          <img
                            class="commodity-show-img"
                            @click="toProductDetail(item.id)"
                            :src="
                              item.cover == '' ||
                              item.cover == null ||
                              item.cover == 'null'
                                ? require('../assets/public/none-icon.png')
                                : item.cover
                            "
                            alt=""
                          />
                        </div>
                        <div class="commodity-show-item-msg">
                          <div class="commodity-show-item-price-modular">
                            <div class="commodity-show-item-price">
                              {{ currencySymbol }}
                              <span style="font-size: 14px">{{
                                item.has_discount == 1
                                  ? item.discount_price
                                  : item.price
                              }}</span>
                            </div>
                            <div
                              class="commodity-show-item-original-price"
                              v-if="item.has_discount == 1"
                            >
                              {{ currencySymbol }}{{ item.price }}
                            </div>
                          </div>

                          <div
                            class="commodity-show-item-introduce"
                            :style="
                              item.title == '' ||
                              item.title == null ||
                              item.title == 'null'
                                ? 'height:47px;'
                                : ''
                            "
                          >
                            {{
                              currLanguage == 3 ? item.eng_title : item.title
                            }}
                          </div>
                          <div class="commodity-show-item-evaluate">
                            <div class="commodity-evaluate">
                              <span class="commodity-evaluate-num">{{
                                item.comment_num
                              }}</span>
                              <span class="commodity-evaluate-title">{{
                                currLanguage == 3 ? "Evaluate" : pageTextArr[31]
                              }}</span>
                            </div>
                            <!-- <div class="commodity-coupon">劵</div> -->
                          </div>
                          <div class="commodity-show-item-operation">
                            <div
                              class="commodity-collection"
                              @click="
                                productaddCollect(
                                  item.product_id,
                                  item.is_collect,
                                  index
                                )
                              "
                            >
                              <img
                                class="collection-icon"
                                src="../assets/home/collection-icon-2.png"
                                alt=""
                              />
                              <span class="collection-title">{{
                                pageTextArr[42]
                              }}</span>
                            </div>
                            <div class="commodity-shop-cart" @click="addCart()">
                              <img
                                class="shop-cart-icon"
                                src="../assets/home/shop-cart-icon.png"
                                alt=""
                              />
                              <span
                                class="add-cart-title"
                                @click="
                                  productAddCart(
                                    item.product_id,
                                    item.sku_number,
                                    1,
                                    '',
                                    1
                                  )
                                "
                                >{{ pageTextArr[43] }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div
                class="pagination-footer-modualr"
                v-if="
                  evaluateHeaderBar.activeBar == 0 &&
                  ProductCollectList.length > 0
                "
              >
                <el-pagination
                  :pager-count="11"
                  background
                  layout="prev, pager, next"
                  :total="pageCount"
                  @current-change="handleCurrentChange"
                >
                </el-pagination>
              </div>
            </div>
            <!-- 优惠券 -->
            <div
              v-else-if="menuActiveIndex == 3"
              class="my-coupon-modualr"
              :style="
                equipmentType == 0 && showCouponDetailData.length <= 3
                  ? 'padding-bottom:60px;'
                  : ''
              "
            >
              <div class="my-coupon-header-modualr">
                <div
                  :class="
                    index == couponHeaderBar.activeBar
                      ? 'evaluate-header-item active-evaluate-item'
                      : 'evaluate-header-item'
                  "
                  v-for="(item, index) in couponHeaderBar.barList"
                  :key="index"
                  @click="clickcoupoHeaderBar(index)"
                >
                  {{ currLanguage == 3 ? item.eng_title : item.title }}({{
                    item.num
                  }})
                </div>
              </div>
              <div class="my-coupon-body-modualr">
                <div
                  v-if="showCouponDetailData.length == 0"
                  class="my-evaluate-bodu-none"
                >
                  <img
                    class="none-icon"
                    src="../assets/public/none-icon.png"
                    alt=""
                  />
                  <p class="none-title">{{ pageTextArr[23] }}</p>
                </div>
                <div class="my-coupon-list-modular" v-else>
                  <el-row :gutter="20" style="width: 100%">
                    <el-col
                      :span="8"
                      :xs="12"
                      v-for="(item, index) in showCouponDetailData"
                      :key="index"
                    >
                      <div class="my-coupon-item">
                        <div class="my-coupon-item-bg">
                          <img
                            class="coupon-bg-img"
                            :src="
                              couponHeaderBar.activeBar == 0
                                ? require('../assets/public/coupon-icon-1.png')
                                : require('../assets/public/coupon-icon-2.png')
                            "
                            alt=""
                          />
                        </div>
                        <div class="my-coupon-detail-item">
                          <div class="my-coupon-money-item">
                            <span class="money-symbol">{{
                              currencySymbol
                            }}</span>
                            <span v-if="item.cate == 1">
                              {{ item.discount }}</span
                            >
                            <span v-if="item.cate == 2"> {{ item.cash }}</span>
                          </div>
                          <!-- 	1折扣券2现金券 -->

                          <div
                            class="my-coupon-rule-item"
                            v-if="item.cate == 1"
                          >
                            {{
                              currLanguage == 3
                                ? "Full" +
                                  item.low_cash +
                                  "OFF" +
                                  parseFloat(item.discount) +
                                  "%"
                                : pageTextArr[47] +
                                  item.low_cash +
                                  pageTextArr[48] +
                                  parseFloat(item.discount) +
                                  "%"
                            }}
                          </div>
                          <!--  currLanguage == 3
                              ? "Full" + item.cash + "Reduce" + item.discount
                                    : "满" + item.low_cash + "减" + item.cash -->
                          <div
                            class="my-coupon-rule-item"
                            v-if="item.cate == 2"
                          >
                            {{
                              pageTextArr[47] +
                              item.low_cash +
                              pageTextArr[48] +
                              item.cash
                            }}
                          </div>

                          <div class="my-coupon-limit-time-item">
                            {{ item.end_time }}
                          </div>
                          <div class="my-coupon-limit-produce-item">
                            {{ item.msg1 }}
                          </div>
                          <div class="my-coupon-number-item">
                            <p>{{ pageTextArr[49] }}</p>
                            <p>{{ item.code }}</p>
                          </div>
                          <div
                            class="my-coupon-btn-item"
                            v-if="couponHeaderBar.activeBar == 0"
                          >
                            <el-button
                              class="my-coupo-use-btn"
                              @click="couponUseNow()"
                            >
                              {{ pageTextArr[50] }}</el-button
                            >
                          </div>
                          <div
                            class="my-coupon-status-item"
                            v-else-if="couponHeaderBar.activeBar == 1"
                          >
                            <img
                              class="coupon-icon"
                              src="../assets/public/coupon-used-icon.png"
                              alt=""
                            />
                          </div>
                          <div
                            class="my-coupon-status-item"
                            v-else-if="couponHeaderBar.activeBar == 2"
                          >
                            <img
                              class="coupon-icon"
                              src="../assets/public/coupon-overdue-icon.png"
                              alt=""
                            />
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div
                  class="pagination-footer-modualr"
                  style="width: 100; text-align: center"
                >
                  <el-pagination
                    :pager-count="11"
                    background
                    layout="prev, pager, next"
                    :total="pageCount"
                    @current-change="handleCurrentChange"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
            <!-- 收货地址 -->
            <div
              v-else-if="menuActiveIndex == 4"
              class="my-shipping-address-modualr"
            >
              <div class="my-shipping-address-header-modualr">
                <el-button
                  class="add-address-btn"
                  @click="showAddressDialog()"
                  >{{ pageTextArr[51] }}</el-button
                >
                <div class="my-shipping-address-heade-title">
                  {{ pageTextArr[52] }}{{ shippingAddressList.length
                  }}{{ pageTextArr[53] }}{{ pageTextArr[54] }},{{
                    pageTextArr[55]
                  }}{{ 20 - shippingAddressList.length }}{{ pageTextArr[54] }}
                </div>
              </div>
              <div class="my-shipping-address-body-modualr">
                <div
                  class="shipping-address-item"
                  v-for="(item, index) in shippingAddressList"
                  :key="index"
                  v-if="index < addressShowLength"
                >
                  <div class="shipping-name-item">
                    {{ item.recivername }}
                    <span class="default-title" v-if="item.default == 1">{{
                      pageTextArr[121]
                    }}</span>
                  </div>
                  <div class="shipping-info-item">
                    <span class="shipping-span-item">{{
                      pageTextArr[56] + "："
                    }}</span>
                    <span class="shipping-value-item">{{
                      item.recivername
                    }}</span>
                  </div>
                  <div class="shipping-info-item">
                    <span class="shipping-span-item">{{
                      pageTextArr[57] + "："
                    }}</span>
                    <span class="shipping-value-item">{{
                      item.province + " " + item.city + " " + item.area
                    }}</span>
                  </div>
                  <div class="shipping-info-item">
                    <span class="shipping-span-item">{{
                      pageTextArr[58] + "："
                    }}</span>
                    <span class="shipping-value-item">{{ item.address }}</span>
                  </div>
                  <div class="shipping-info-item">
                    <span class="shipping-span-item">{{
                      pageTextArr[59] + "："
                    }}</span>
                    <span class="shipping-value-item">{{ item.mobile }}</span>
                  </div>
                  <div class="shipping-info-item">
                    <span class="shipping-span-item">{{
                      pageTextArr[60] + "："
                    }}</span>
                    <span class="shipping-value-item">{{ item.email }}</span>
                  </div>
                  <img
                    class="close-icon"
                    src="../assets/public/close-icon-2.png"
                    alt=""
                    @click="deleteAddress(item.id)"
                  />
                  <div class="shipping-edit-item">
                    <span
                      class="default-btn"
                      v-if="item.default == 0"
                      @click="shippingDefault(item.id)"
                      >{{ pageTextArr[61] }}</span
                    >
                    <span class="edit-btn" @click="shippingEdit(index)">{{
                      pageTextArr[62]
                    }}</span>
                  </div>
                </div>
                <div
                  class="view-more"
                  v-if="
                    addressShowLength != shippingAddressList.length &&
                    shippingAddressList.length > 3
                  "
                  @click="viewMoreAddress()"
                >
                  {{ $t("translateText.viewmoreText") }}
                </div>
              </div>
            </div>
            <!-- 我的帖子 -->
            <div v-else-if="menuActiveIndex == 5" class="my-post-modualr">
              <div class="my-post-header-modualr">
                <div
                  :class="
                    index == postHeaderBar.activeBar
                      ? 'post-header-item active-post-item'
                      : 'post-header-item'
                  "
                  v-for="(item, index) in postHeaderBar.barList"
                  :key="index"
                  @click="clickPostHeaderBar(index)"
                >
                  {{ currLanguage == 3 ? item.eng_title : item.title }}
                </div>
              </div>
              <div class="my-post-body-modualr">
                <!-- 我的帖子列表 -->
                <div
                  v-if="postHeaderBar.activeBar == 0 && postData.length == 0"
                  class="my-evaluate-bodu-none"
                >
                  <img
                    class="none-icon"
                    src="../assets/public/none-icon.png"
                    alt=""
                  />
                  <p class="none-title">{{ pageTextArr[23] }}</p>
                </div>
                <div
                  class="my-post-body-modualr"
                  v-if="postHeaderBar.activeBar == 0 && postData.length > 0"
                >
                  <div class="my-post-body-tbody">
                    <div
                      class="my-post-body-item"
                      v-for="(item, index) in postData"
                      :key="index"
                      @click="toForumDetail(item.id)"
                    >
                      <div
                        class="my-post-body-time"
                        style="display: flex; justify-content: space-between"
                      >
                        <div>{{ item.create_time }}</div>
                        <div style="color: #ec0000">
                          {{
                            item.rank == 1
                              ? "待审核"
                              : item.rank == -1
                              ? "审核未通过/被删除"
                              : ""
                          }}
                        </div>
                      </div>
                      <div class="my-post-body-title">{{ item.title }}</div>
                      <div class="my-post-body-content">
                        <div v-html="item.detail"></div>
                      </div>
                      <div class="my-post-body-msg-footer">
                        <div class="my-post-tag">
                          {{ getTypeNameById(item.type_id) }}
                        </div>
                        <div class="my-post-icon-num">
                          <div class="my-post-disFlex">
                            <img
                              src="../assets/forum/news-icon.png"
                              alt=""
                              class="news-icon"
                            />
                            <div>{{ item.comment }}</div>
                          </div>
                          <div class="my-post-disFlex margin30">
                            <img
                              src="../assets/blog/view-icon.png"
                              alt=""
                              class="view-icon"
                            />
                            <div>{{ item.click }}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 帖子分页 -->
                <div
                  class="pagination-footer-modualr"
                  v-if="postHeaderBar.activeBar == 0 && postData.length > 0"
                >
                  <el-pagination
                    :pager-count="11"
                    background
                    layout="prev, pager, next"
                    :total="pageCount"
                    @current-change="handleCurrentChange"
                  >
                  </el-pagination>
                </div>
                <!-- 我回复的 -->
                <div
                  v-if="
                    postHeaderBar.activeBar == 1 && postreplyData.length == 0
                  "
                  class="my-evaluate-bodu-none"
                >
                  <img
                    class="none-icon"
                    src="../assets/public/none-icon.png"
                    alt=""
                  />
                  <p class="none-title">{{ pageTextArr[23] }}</p>
                </div>
                <div
                  class="my-post-body-modualr"
                  v-if="
                    postHeaderBar.activeBar == 1 && postreplyData.length > 0
                  "
                >
                  <div class="my-post-body-tbody">
                    <div
                      class="my-post-body-item"
                      v-for="(item, index) in postreplyData"
                      :key="index"
                      @click="toForumDetail(item.blog_id)"
                    >
                      <div class="my-post-body-time">{{ item.time }}</div>
                      <div class="my-post-body-title">
                        {{ item.comment }}
                      </div>
                      <div class="my-post-body-post">
                        {{ pageTextArr[67] + ":" + item.title }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 博客分页 -->
                <div
                  class="pagination-footer-modualr"
                  v-if="
                    postHeaderBar.activeBar == 1 && postreplyData.length > 0
                  "
                >
                  <el-pagination
                    :pager-count="11"
                    background
                    layout="prev, pager, next"
                    :total="pageCount"
                    @current-change="handleCurrentChange"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>

            <!-- 个人信息 -->
            <div
              v-else-if="menuActiveIndex == 6"
              class="my-post-modualr my-user-info-modular"
            >
              <div class="my-post-header-modualr">
                <div
                  :class="
                    index == userHeaderBar.activeBar
                      ? 'post-header-item active-post-item'
                      : 'post-header-item'
                  "
                  v-for="(item, index) in userHeaderBar.barList"
                  :key="index"
                  @click="clickUserHeaderBar(index)"
                >
                  {{ currLanguage == 3 ? item.eng_title : item.title }}
                </div>
              </div>
              <div
                class="userInfo-body-modualr"
                v-if="userHeaderBar.activeBar == 0"
              >
                <el-form ref="form" :model="userInfoForm" label-width="80px">
                  <div class="userInfo-disFlex magin30">
                    <img :src="userInfoForm.head_img" alt="" class="face-img" />
                    <span class="edit-face" @click="editFaceDialog">{{
                      pageTextArr[68]
                    }}</span>
                  </div>
                  <el-form-item :label="pageTextArr[69]">
                    <el-input v-model="userInfoForm.userName"></el-input>
                  </el-form-item>
                  <el-form-item :label="pageTextArr[70]">
                    <el-radio-group
                      v-model="userInfoForm.sex"
                      fill="#EC0000"
                      text-color="#EC0000"
                    >
                      <el-radio label="0">{{ pageTextArr[71] }}</el-radio>
                      <el-radio label="1">{{ pageTextArr[72] }}</el-radio>
                      <el-radio label="3">{{ pageTextArr[73] }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item :label="pageTextArr[74]">
                    <div class="replace-disflex">
                      {{ getMobile(userInfoForm.mobile) }}
                      <!-- <span class="replaceBtn" @click="replacePhoneDialog">{{
                        pageTextArr[75]
                      }}</span> -->
                    </div>
                  </el-form-item>
                  <el-form-item :label="pageTextArr[76]">
                    <div class="replace-disflex">
                      {{ getEmail(userInfoForm.email) }}
                      <span class="replaceBtn" @click="replaceEmailDialog">{{
                        pageTextArr[75]
                      }}</span>
                    </div>
                  </el-form-item>
                  <el-form-item :label="pageTextArr[77]">
                    <div class="nation-input">
                      <el-input
                        v-model="userInfoForm.country"
                        @focus="selectNation"
                      ></el-input>
                      <img
                        class="select-icon nation"
                        src="../assets/public/up-arrow-icon.png"
                        alt=""
                      />
                    </div>
                  </el-form-item>
                  <el-form-item :label="pageTextArr[78]">
                    <el-row>
                      <el-col :span="8" :xs="24" class="birthday-time">
                        <el-date-picker
                          v-model="userInfoForm.year"
                          type="year"
                          :placeholder="pageTextArr[79]"
                          format="yyyy"
                          value-format="yyyy"
                        >
                        </el-date-picker>
                        <div class="birthday-time-item">
                          {{ pageTextArr[82] }}
                        </div>
                      </el-col>
                      <el-col :span="8" :xs="24" class="birthday-time">
                        <el-date-picker
                          v-model="userInfoForm.month"
                          type="month"
                          :placeholder="pageTextArr[80]"
                          format="MM"
                          value-format="MM"
                        >
                        </el-date-picker>
                        <div class="birthday-time-item">
                          {{ pageTextArr[83] }}
                        </div>
                      </el-col>
                      <el-col :span="8" :xs="24" class="birthday-time">
                        <el-date-picker
                          v-model="userInfoForm.day"
                          type="date"
                          :placeholder="pageTextArr[81]"
                          format="dd"
                          value-format="dd"
                        >
                        </el-date-picker>
                        <div class="birthday-time-item time-date">
                          {{ pageTextArr[84] }}
                        </div>
                      </el-col>
                    </el-row>
                  </el-form-item>
                  <el-form-item :label="pageTextArr[85]">
                    <el-input v-model="userInfoForm.company"></el-input>
                  </el-form-item>
                  <div class="userInfo-save">
                    <el-button class="save-button" @click="updateUserInfo()">{{
                      pageTextArr[86]
                    }}</el-button>
                    <!-- <button type="button" class="save-button" @click="updateUserInfo()">保存</button> -->
                  </div>
                </el-form>
              </div>
              <div
                class="userInfo-body-modualr"
                v-if="userHeaderBar.activeBar == 1"
              >
                <div class="edit-password-content">
                  <el-form
                    label-position="top"
                    label-width="80px"
                    :model="formEditPassword"
                  >
                    <el-form-item :label="pageTextArr[87]">
                      <el-input
                        type="password"
                        v-model="formEditPassword.oldPassword"
                        :placeholder="pageTextArr[90]"
                      ></el-input>
                    </el-form-item>
                    <el-form-item :label="pageTextArr[88]">
                      <el-input
                        autocomplete="new"
                        type="password"
                        v-model="formEditPassword.newPassword"
                        :placeholder="pageTextArr[91]"
                      ></el-input>
                    </el-form-item>
                    <el-form-item :label="pageTextArr[89]">
                      <el-input
                        autocomplete="new"
                        type="password"
                        v-model="formEditPassword.surePassword"
                        :placeholder="pageTextArr[91]"
                      ></el-input>
                    </el-form-item>
                  </el-form>
                  <div class="userInfo-save">
                    <el-button class="save-button" @click="confirmSave()">{{
                      pageTextArr[86]
                    }}</el-button>
                    <!-- <button class="save-button">保存</button> -->
                  </div>
                </div>
              </div>
              <div
                class="userInfo-body-modualr"
                v-if="userHeaderBar.activeBar == 2"
              >
                <div class="account-bind-content">
                  <div
                    class="account-bind-item"
                    v-for="(item, index) in bindAccountList"
                    :key="index"
                  >
                    <div class="account-bind-disFlex">
                      <img :src="item.icon" alt="" class="bind-icon" />
                      <div class="account-bind-name">{{ item.name }}</div>
                    </div>
                    <div class="account-bind-nickName">
                      {{
                        item.bindStatus == 0 ? pageTextArr[92] : item.nickName
                      }}
                    </div>
                    <div
                      :class="
                        item.bindStatus == 0
                          ? 'green-text bind-status'
                          : 'red-text'
                      "
                    >
                      {{
                        item.bindStatus == 0 ? pageTextArr[93] : pageTextArr[94]
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 手机样式-物流信息 -->
    <el-dialog title="物流信息" :visible.sync="showLogistics" width="95%">
      <div class="order-logistics-popover-header">
        <div class="order-logistics-popover-header-left">
          <span class="logisticsName">{{ logisticsData.logisticsName }}</span>
          <span class="courierNumber"
            >快递单号：{{ logisticsData.courierNumber }}</span
          >
        </div>
        <div class="order-logistics-popover-header-right">更多></div>
      </div>
      <div class="order-logistics-popover-body">
        <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in logisticsData.timelineData"
            :key="index"
            :icon="activity.icon"
            :type="activity.type"
            :color="activity.color"
            :size="activity.size"
            :timestamp="activity.timestamp"
            placement="top"
          >
            <h4 v-if="activity.content != null">{{ activity.content }}</h4>
            <p v-if="activity.info != null">{{ activity.info }}</p>
          </el-timeline-item>
        </el-timeline>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showLogistics = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 新增收货地址 -->
    <el-dialog
      :title="showAddaddressTitle"
      :visible.sync="showAddaddressDialog"
      :close-on-click-modal="false"
    >
      <div class="dialog-add-address-modualr">
        <div class="dialog-add-address-body-modualr">
          <div class="dialog-add-address-info-item">
            <div class="dialog-add-address-info-header-title-item">
              <span class="red-icon">*</span>
              <span class="address-info-header-title">{{
                pageTextArr[56]
              }}</span>
            </div>
            <div class="dialog-add-address-info-input-item">
              <el-input
                autocomplete="new"
                v-model="addShippingAddressInfo.recivername"
                :placeholder="pageTextArr[56]"
              ></el-input>
            </div>
          </div>
          <div class="dialog-add-address-info-item">
            <div class="dialog-add-address-info-header-title-item">
              <span class="red-icon">*</span>
              <span class="address-info-header-title">{{
                pageTextArr[97]
              }}</span>
            </div>
            <div class="dialog-add-address-info-select-item">
              <el-row :gutter="20">
                <el-col :span="6" :xs="24">
                  <el-select
                    autocomplete="new"
                    v-model="currCountryId"
                    filterable
                    :placeholder="pageTextArr[98]"
                    @change="selectCountryChange()"
                  >
                    <el-option
                      v-for="item in countryData"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="6" :xs="24" v-show="showAddressItem">
                  <el-select
                    autocomplete="new"
                    v-model="currProvinceId"
                    filterable
                    :placeholder="pageTextArr[99]"
                    @change="getCity()"
                  >
                    <el-option
                      v-for="item in provinceData"
                      :key="item.id"
                      :label="item.name"
                      :value="item.code"
                      @click="getCity"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="6" :xs="24" v-show="showAddressItem">
                  <el-select
                    autocomplete="new"
                    v-model="currCityid"
                    filterable
                    :placeholder="pageTextArr[100]"
                    @change="getArea()"
                  >
                    <el-option
                      v-for="item in cityData"
                      :key="item.id"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="6" :xs="24" v-show="showAddressItem">
                  <el-select
                    autocomplete="new"
                    v-model="currAreaId"
                    filterable
                    :placeholder="pageTextArr[101]"
                  >
                    <el-option
                      v-for="item in AreaData"
                      :key="item.id"
                      :label="item.name"
                      :value="item.code"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>

              <!-- <el-cascader v-model="selectAreaValue" filterable :options="areaData" @change="handleChange"
                                                                      placeholder="请选择上省市区"></el-cascader> -->
            </div>
          </div>
          <div class="dialog-add-address-info-item">
            <div class="dialog-add-address-info-header-title-item">
              <span class="red-icon">*</span>
              <span class="address-info-header-title">{{
                pageTextArr[58]
              }}</span>
            </div>
            <div class="dialog-add-address-info-input-item">
              <el-input
                autocomplete="new"
                v-model="addShippingAddressInfo.address"
                :placeholder="pageTextArr[102]"
              ></el-input>
            </div>
          </div>
          <div class="dialog-add-address-info-item">
            <div class="dialog-add-address-info-header-title-item">
              <span class="red-icon">*</span>
              <span class="address-info-header-title">{{
                pageTextArr[74]
              }}</span>
            </div>
            <div class="dialog-add-address-info-input-item">
              <el-row :gutter="20">
                <el-col :span="8" :xs="24">
                  <el-select
                    autocomplete="new"
                    v-model="selectCompany"
                    filterable
                    :placeholder="$t('translateText.placeholderText')"
                  >
                    <el-option
                      v-for="item in countryData"
                      :key="item.id"
                      :label="item.name + item.area_code"
                      :value="item.area_code"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="16" :xs="24">
                  <el-input
                    class="input-phone-item"
                    v-model="addShippingAddressInfo.mobile"
                    :placeholder="pageTextArr[103]"
                  ></el-input>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="dialog-add-address-info-item">
            <div class="dialog-add-address-info-header-title-item">
              <span class="red-icon">*</span>
              <span class="address-info-header-title">{{
                pageTextArr[76]
              }}</span>
            </div>
            <div class="dialog-add-address-info-input-item">
              <el-input
                v-model="addShippingAddressInfo.email"
                :placeholder="pageTextArr[104]"
              ></el-input>
            </div>
          </div>
        </div>
        <div class="dialog-add-address-footer-modualr">
          <el-button class="add-address-btn" @click="editAddress()">{{
            pageTextArr[34]
          }}</el-button>
        </div>
      </div>
      <!-- <span>这是一段信息</span>
                                                  <span slot="footer" class="dialog-footer">
                                                    <el-button type="primary" @click="showAddaddressDialog = false">确 定</el-button>
                                                        </span> -->
    </el-dialog>
    <!-- 修改头像 -->
    <el-dialog
      :title="pageTextArr[68]"
      :visible.sync="showeditFace"
      width="40%"
      class="upload-face-dialog"
    >
      <div>
        <el-upload
          :action="uploadImgUrl"
          :headers="headerData"
          :file-list="imgFileList"
          :on-change="beforeFileUpload"
          :on-success="uploadImgSeccess"
          :limit="1"
        >
          <button class="upload-img-btn">
            {{ pageTextArr[105] }}
          </button>
          <div slot="tip" class="el-upload__tip">
            {{ pageTextArr[106] }}<br />{{ pageTextArr[107] }}
          </div>
        </el-upload>
        <div class="show-img">
          <img :src="uoloadSuccessImgUrl" alt="" />
        </div>
        <div>
          <el-button class="save-button" @click="saveUserInfoFace()">{{
            pageTextArr[86]
          }}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 修改手机号码 -->
    <el-dialog
      :title="editoldEmailDialog ? pageTextArr[109] : pageTextArr[108]"
      :visible.sync="editoldPhoneDialog"
      class="upload-phone-dialog"
      @close="closeDialog"
    >
      <!-- 修改手机号码1 -->
      <div v-if="editoldPhone">
        <div class="forget-text">
          {{ editoldEmailDialog ? pageTextArr[123] : pageTextArr[122] }}
        </div>
        <div class="address-text">
          {{ pageTextArr[110]
          }}{{ editoldEmailDialog ? pageTextArr[125] : pageTextArr[124] }}。
        </div>
        <div class="phone-input">
          <span class="title">
            <span class="red-color">*</span>
            {{ editoldEmailDialog ? pageTextArr[60] : pageTextArr[59] }}</span
          >
          <input
            type="text"
            :class="
              editoldEmailDialog
                ? 'account padding20 phone-suffix'
                : 'account padding100 phone-suffix'
            "
            v-model="checkEmial"
          />
          <div class="phone-prefix-modular" v-if="!editoldEmailDialog">
            <el-select
              v-model="currTel"
              filterable
              class="country-tel-select"
              :placeholder="pageTextArr[127]"
            >
              <el-option
                v-for="item in countryTelData"
                :key="item.id"
                :label="item.area_code"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div>
          <button class="login-button" @click="tophoneVerification()">
            {{ pageTextArr[111] }}
          </button>
        </div>
      </div>
      <!-- 修改手机号码2 -->
      <div v-if="oldphoneVerification">
        <div class="forget-text">
          {{ pageTextArr[126] }}
        </div>
        <div class="address-text">
          {{ pageTextArr[112] }}
          {{ editoldEmailDialog ? pageTextArr[60] : pageTextArr[59] }}<br />{{
            editoldEmailDialog ? "" : phonePrefix
          }}
          {{ oldPhone + pageTextArr[113] }}
        </div>
        <div class="phone-input">
          <span class="title">
            <span class="red-color">*</span>
            {{ pageTextArr[114] }}</span
          >
          <input
            type="text"
            class="account padding20 phone-suffix"
            v-model="verificationcode"
          />
        </div>
        <div>
          <button class="login-button" @click="checkEmailCode">
            {{ pageTextArr[111] }}
          </button>
        </div>
      </div>
      <!-- 修改手机号码3 -->
      <div v-if="editnewPhone">
        <div class="forget-text">
          {{ pageTextArr[115] }}
          {{ editoldEmailDialog ? pageTextArr[60] : pageTextArr[59] }}
        </div>
        <div class="address-text">
          {{ pageTextArr[116] }}
          <!-- 输入要关联的新{{ editoldEmailDialog?'邮箱': '手机号码' }}。我们将向该号码发送验证代码。 -->
        </div>
        <div class="phone-input">
          <span class="title">
            <span class="red-color">*</span>
            {{ editoldEmailDialog ? pageTextArr[60] : pageTextArr[59] }}</span
          >
          <input
            type="text"
            :class="
              editoldEmailDialog
                ? 'account padding20 phone-suffix'
                : 'account padding100 phone-suffix'
            "
            v-model="newMobile"
          />
          <div class="phone-prefix-modular" v-if="!editoldEmailDialog">
            <input type="text" class="phone-prefix" v-model="phonePrefix" />
            <img
              class="select-icon"
              src="../assets/public/up-arrow-icon.png"
              alt=""
            />
          </div>
        </div>
        <div>
          <button class="login-button" @click="updateEmail()">
            {{ pageTextArr[34] }}
          </button>
        </div>
      </div>
      <!-- 修改手机号码4 -->
      <div v-if="newphoneVerification">
        <div class="forget-text">
          {{ pageTextArr[117] }}
        </div>
        <div class="address-text">
          {{ pageTextArr[112] }}
          {{ editoldEmailDialog ? pageTextArr[60] : pageTextArr[59] }}<br />{{
            editoldEmailDialog ? "" : phonePrefix
          }}
          {{ oldPhone + pageTextArr[113] }}
        </div>
        <div class="phone-input">
          <span class="title">
            <span class="red-color">*</span>
            {{ pageTextArr[114] }}</span
          >
          <input
            type="text"
            class="account padding20 phone-suffix"
            v-model="verificationcode"
          />
        </div>
        <div>
          <button class="login-button" @click="tonewPhoneSure">
            {{ pageTextArr[34] }}
          </button>
        </div>
      </div>
    </el-dialog>
    <!-- 选择国家 -->
    <el-dialog
      :title="$t('translateText.titlecpuntryselect')"
      :visible.sync="selectNationDialog"
      width="50%"
      class="select-nation-dialog"
    >
      <div class="select-nation-content">
        <div class="select-nation-title">
          <div
            @click="selectNationTitle(0)"
            :class="nationTitle == 0 ? 'active-title' : 'select-title-item'"
          >
            {{ pageTextArr[98] }}
          </div>
          <div
            @click="selectNationTitle(1)"
            :class="
              nationTitle == 1
                ? 'active-title margin40'
                : 'margin40 select-title-item'
            "
          >
            ABCDEF
          </div>
          <div
            @click="selectNationTitle(2)"
            :class="
              nationTitle == 2
                ? 'active-title margin40'
                : 'margin40 select-title-item'
            "
          >
            GHIJ
          </div>
          <div
            @click="selectNationTitle(3)"
            :class="
              nationTitle == 3
                ? 'active-title margin40'
                : 'margin40 select-title-item'
            "
          >
            KLMN
          </div>
          <div
            @click="selectNationTitle(4)"
            :class="
              nationTitle == 4
                ? 'active-title margin40'
                : 'margin40 select-title-item'
            "
          >
            PQRSTUV
          </div>
          <div
            @click="selectNationTitle(5)"
            :class="
              nationTitle == 5
                ? 'active-title margin40'
                : 'margin40 select-title-item'
            "
          >
            WXYZ
          </div>
        </div>
        <div class="select-nation-name-content">
          <div class="select-nation-name" v-if="nationTitle == 1">
            <div
              :class="
                item.id == currCountryId
                  ? 'countrt-item countrt-item-active'
                  : 'countrt-item'
              "
              v-for="(item, index) in countryData"
              @click="selectCpuntry(item.id, item.name)"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <el-button class="login-button" @click="tonationSure">{{
          pageTextArr[86]
        }}</el-button>
        <!-- <button class="login-button" @click="tonationSure">保存</button> -->
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currencySymbol: localStorage.getItem("currencySymbol"),
      addressShowLength: 3, //显示的地址长度，默认显示三个
      showAddressItem: false, //省市区显示
      currLanguage: 1, //当前语言
      showAddaddressDialogWidth: "", //添加到货地址弹窗宽度
      showAddaddressTitle: "添加收货地址",
      showAddaddressDialog: false, //收货地址弹窗
      searchKey: "", //关键词搜索
      collectionSearchKey: "",
      page: 1,
      pagesize: 10,
      pageCount: 0, //总页数
      // menu-index 控制显示
      showOrder: true,
      order_id: null,
      uploadImgData: [], //上传的图片
      appraiseProduct: [], //需要评论的组合产品
      appraiseoneProduct: [], //需要评论的单个产品
      appraiseImgList: [], //评价图片
      appraiseText: "",
      statNum: 0, //星级数量
      menuActiveIndex: 0,
      menuList: [
        {
          index: 0,
          title: "我的订单",
          flag: true,
          icon1: require("../assets/myOrder/order-icon-1.png"),
          icon2: require("../assets/myOrder/order-icon-2.png"),
        },
        {
          index: 1,
          title: "我的评论",
          flag: false,
          icon1: require("../assets/myOrder/comment-icon-1.png"),
          icon2: require("../assets/myOrder/comment-icon-2.png"),
        },
        {
          index: 2,
          title: "我的收藏",
          flag: false,
          icon1: require("../assets/myOrder/collection-icon-1.png"),
          icon2: require("../assets/myOrder/collection-icon-2.png"),
        },
        {
          index: 3,
          title: "优惠券",
          flag: false,
          icon1: require("../assets/myOrder/coupon-icon-1.png"),
          icon2: require("../assets/myOrder/coupon-icon-2.png"),
        },
        {
          index: 4,
          title: "收货地址",
          flag: false,
          icon1: require("../assets/myOrder/address-icon-1.png"),
          icon2: require("../assets/myOrder/address-icon-2.png"),
        },
        {
          index: 5,
          title: "我的贴子",
          flag: false,
          icon1: require("../assets/myOrder/post-icon-1.png"),
          icon2: require("../assets/myOrder/post-icon-2.png"),
        },
        {
          index: 6,
          title: "个人信息",
          flag: false,
          icon1: require("../assets/myOrder/user-info-icon-1.png"),
          icon2: require("../assets/myOrder/user-info-icon-2.png"),
        },
      ],
      orderMenuActive: 0,
      order_status: 0, //0全部1待支付3待发货4待收货7已完成
      orderMenu: [
        {
          index: 0,
          title: "全部订单",
          num: 0,
        },
        {
          index: 1,
          title: "待支付",
          num: 0,
        },
        {
          index: 2,
          title: "待发货",
          num: 0,
        },
        {
          index: 5,
          title: "待收货",
          num: 0,
        },
        {
          index: 3,
          title: "待评价",
          num: 0,
        },
        {
          index: 4,
          title: "已完成",
          num: 0,
        },
      ],
      // 订单列表
      orderList: [],
      orderListloading: false, //订单列表-loading
      // 我的收藏-列表
      ProductCollectList: [],
      // 物流信息
      logisticsData: {
        logisticsName: "邦德快递",
        courierNumber: "db37200006162002",
        timelineData: [
          {
            content: "已签收",
            info: "正常签收，签收人类型：本人，如有疑问请联系：15100001178。",
            timestamp: "2018-04-12 20:46",
            size: "large",
            type: "primary",
            icon: "el-icon-check",
            color: "#EC0000",
          },
          {
            content: "派送中",
            info: "[苏州吴中区车坊镇经营分部]派件员：薛向阳 电话：16626332235 ，派送中，德邦已开启”安全呼叫“，保护您的电话隐私,如有疑问，请联系：0512-51939188",
            timestamp: "2018-04-03 20:46",
          },
          {
            content: "运输中",
            info: "",
            timestamp: "2018-04-03 20:46",
            size: "large",
          },
          {
            content: "",
            info: "[泰安市转运中心公司]已发出",
            timestamp: "2018-04-03 20:46",
          },
          {
            content: "",
            info: "[泰安市转运中心公司]已收入",
            timestamp: "2018-04-03 20:46",
          },
          {
            content: "出库",
            info: "",
            timestamp: "2018-04-03 20:46",
          },
        ],
      },
      showLogistics: false, //显示物信息
      // 手机端，PC端
      equipmentType: 0,
      // 我的评价
      evaluateHeaderBar: {
        activeBar: 0,
        barList: [
          {
            title: "产品",
            eng_title: "Product",
          },
          {
            title: "博客",
            eng_title: "Blog",
          },
        ],
      },
      // 评价数据
      evaluateData: [],
      // 我的评价 - 博客数据
      blogListData: [
        // {
        //   dateTime: "022-11-11  08:08",
        //   title: "说的很有道理，学到了",
        //   replyContent: "如何用普惠t890 拆卸芯片",
        // },
        // {
        //   dateTime: "022-11-11  08:08",
        //   title: "说的很有道理，学到了",
        //   replyContent: "如何用普惠t890 拆卸芯片",
        // },
        // {
        //   dateTime: "022-11-11  08:08",
        //   title: "说的很有道理，学到了",
        //   replyContent: "如何用普惠t890 拆卸芯片",
        // },
      ],
      // 优惠券
      coupon_is_use: 1, //1未使用2已使用
      coupon_time_status: 1, //1未过期2已过期 未使用
      couponHeaderBar: {
        activeBar: 0,
        barList: [
          {
            title: "可用",
            eng_title: "available",
            num: 0,
          },
          {
            title: "已用",
            eng_title: "used",
            num: 0,
          },
          {
            title: "过期",
            eng_title: "expire",
            num: 0,
          },
        ],
      },
      showCouponDetailData: [],
      addressEditStauts: 0, //0-添加，1-编辑
      countryData: [], //国家数据
      currCountryId: "", //当前国家ID
      currCountryName: "", //当前国家名字
      provinceData: [], //省数据
      currProvinceId: "", //当前省ID
      cityData: [], //市数据
      currCityid: "", //当前市ID
      AreaData: [], //区数据
      currAreaId: "", //当前区ID
      // 收货地址
      shippingAddressList: [],
      // 添加收货地址
      addShippingAddressInfo: {
        recivername: "", //收货人姓名
        mobile: "", //手机号码
        country_id: "", //国家id
        email: "", //邮箱
        address: "", //详细地址1
        address2: "", //详细地址2
        is_default: 0, //默认地址-0：不是默认 1：默认地址
        provinceid: "", //省市区
        cityid: "", //市
        areaid: "", //区
      },
      // 上传图片的url
      uploadImgUrl:
        localStorage.getItem("genericBaseUrl") + "/Home/Common/uploadimage",
      headerData: {}, //上传图片的header参数
      // productImportData: {},//上传图片的data参数
      selectAreaValue: "",
      uoloadSuccessImgUrl: "", //长传成功之后的图片
      imgFileList: [],
      // 区域数据
      areaData: [],
      selectCompany: "中国大陆 +86",
      // 我的帖子头部
      postHeaderBar: {
        activeBar: 0,
        barList: [
          {
            title: "我的帖子",
            eng_title: "My Post",
          },
          {
            title: "我回复的",
            eng_title: "I replied",
          },
        ],
      },
      // 我的帖子
      postData: [],
      // 我回复的
      postreplyData: [],
      userHeaderBar: {
        activeBar: 0,
        barList: [
          {
            title: "基本信息",
            eng_title: "Essential information",
          },
          {
            title: "修改密码",
            eng_title: "Change password",
          },
          // {
          //   title: "账号绑定",
          // },
        ],
      },
      //当前登录者个人信息
      userInfoForm: {
        face: "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fc-ssl.duitang.com%2Fuploads%2Fblog%2F202106%2F13%2F20210613235426_7a793.thumb.1000_0.jpeg&refer=http%3A%2F%2Fc-ssl.duitang.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1677552376&t=db5c65c7d87a436cb5d3f14f9f2a6469",
        userName: "本杰明",
        gender: "0",
        phone: "13011111222",
        nation: "中国",
        email: "jinxiahce@foxmail.com",
        company: "江苏爱察信息技术有限公司",
        year: "",
        month: "",
        day: "",
      },
      showeditFace: false,
      editoldPhoneDialog: false, //修改手机的弹窗
      editoldEmailDialog: false, //修改邮箱
      editoldPhone: false, //输入原手机号
      phonePrefix: "+86",
      oldPhone: "",
      newMobile: "", //新手机号
      oldphoneVerification: false, //输入原手机号验证码
      checkEmial: "", //发送验证的邮箱
      verificationcode: "",
      editnewPhone: false, //输入新手机号
      newphoneVerification: false, //输入新手机号验证码

      selectNationDialog: false,
      nationTitle: 1,

      formEditPassword: {
        oldPassword: "",
        newPassword: "",
        surePassword: "",
      },
      bindAccountList: [
        {
          icon: require("../assets/login-icon/QQ.png"),
          name: "QQ",
          bindStatus: 0,
          nickName: "昵称阿冬",
        },
        {
          icon: require("../assets/login-icon/weixin.png"),
          name: "微信",
          bindStatus: 0,
          nickName: "昵称阿冬",
        },
        {
          icon: require("../assets/login-icon/google.png"),
          name: "google",
          bindStatus: 0,
          nickName: "",
        },
        {
          icon: require("../assets/login-icon/paypal.png"),
          name: "paypal",
          bindStatus: 0,
          nickName: "",
        },
        {
          icon: require("../assets/login-icon/vk.png"),
          name: "vk",
          bindStatus: 0,
          nickName: "",
        },
      ],
      inputSelectedIndexs: [-1, -1], // 数组输入框索引值
      proIndex: null,
      type: null,
      proFileIndex: [-1, -1],
      uploadUrl:
        localStorage.getItem("genericBaseUrl") + "/Home/Common/uploadimage",
      countryTelData: [], //电话区域数据
      currTel: "", //国家tel

      pageTextArr: [
        "编辑",
        "个人中心",
        "我的订单",
        "我的评论",
        "我的收藏",
        "优惠券",
        "收货地址",
        "我的帖子",
        "个人信息",
        "全部订单",
        "待支付",
        "待发货",
        "待收货",
        "待评价",
        "已完成",
        "输入关键词",
        "产品信息",
        "单价",
        "数量",
        "实付款",
        "交易状态",
        "操作",
        "订单号",
        "暂无数据",
        "待付款",
        "待发货",
        "待收货",
        "交易成功",
        "付款",
        "取消订单",
        "确认收货",
        "评价",
        "成功",
        "失败",
        "确定",
        "取消",
        "确定删除当前订单？",
        "订单详情",
        "产品",
        "博客",
        "评价详情",
        "输入产品名称",
        "收藏",
        "加入购物车",
        "可用",
        "已用",
        "过期",
        "消费满足",
        "减去",
        "优惠券编号",
        "立即使用",
        "新增收货地址",
        "已保存",
        "数量",
        "地址",
        "还能保存",
        "收货人",
        "所在地址",
        "详细地址",
        "手机",
        "邮箱",
        "设为默认",
        "编辑",
        "我的帖子",
        "我的回复",
        "基本信息",
        "修改密码",
        "回复帖子",
        "修改头像",
        "姓名",
        "性别",
        "男",
        "女",
        "保密",
        "电话",
        "更换",
        "邮箱",
        "国家",
        "生日",
        "选择年",
        "选择月",
        "选择日",
        "年",
        "月",
        "日",
        "公司",
        "保存",
        "原密码",
        "新密码",
        "确认密码",
        "请输入原密码",
        "请输入新密码",
        "未绑定",
        "绑定",
        "解绑",
        "编辑收货地址",
        "请填写收货地址",
        "所在地区",
        "请选择国家",
        "请选择省",
        "请选择市",
        "请选择区",
        "请输入详细地址",
        "请输入收货人电话",
        "请输入邮箱",
        "上传图片",
        "支持jpg、jpeg、png 格式的图片",
        "推荐尺寸：200*200或等比例图片",
        "修改手机号码",
        "修改邮箱",
        "输入与您的 锦格 账户相关联的",
        "继续",
        "要继续，请完成此验证步骤。 我们已向",
        "发送了验证码。 请在下面输入。",
        "验证码",
        "新",
        "输入要关联的新的邮箱。并点击确认更换",
        "验证信息",
        "输入要关联的新的手机号。并点击确认更换",
        "输入要关联的新的手机号。并点击确认更换",
        "输入要关联的新的手机号。并点击确认更换",
        "默认",
        "原手机号码",
        "原邮箱地址",
        "手机号码",
        "邮箱地址",
        "验证信息",
        "请选择",
      ],
    };
  },
  methods: {
    /**
     * 分页点击
     * @param {*} val
     */
    handleCurrentChange(val) {
      let that = this;
      that.page = val;
      switch (that.menuActiveIndex) {
        case 0:
          // 我的订单
          that.getUserOrderList();
          // that.getUserOrderCount();
          break;
        case 1:
          if (that.evaluateHeaderBar.activeBar == 0) {
            // 我的评价
            that.getUserProductCommentList();
          } else {
            // 博客
            that.getMyCommentBlogList();
          }
          break;
        case 2:
          // 我的收藏
          that.getUserProductCollectList();
          break;
        case 3:
          // 优惠券
          that.getUserCoupon();
          break;
        case 4:
          break;
        case 5:
          if (that.postHeaderBar.activeBar == 0) {
            // 我的帖子
            that.getUserBlog();
          } else {
            // 我回复的
            that.myComment();
          }
          break;

        default:
          break;
      }
    },

    /**
     * 支付
     */
    orderPay(endprice, orderNumber, id) {
      let that = this;
      let data = {
        order_number: orderNumber, //订单编号
        money: endprice, //支付金额
        currency: localStorage.getItem("currencyName"), // USD 默认美元
      };

      this.$http.orderPay(
        data,
        (res) => {
          if (res.ret == 1) {
            location.href = res.approval_url;

            // let payUrl = window.open("", "订单支付");
            // let { href } = this.$router.resolve({path:res.approval_url})
            // payUrl.location.href = href;
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 国家选择
     */
    selectCountryChange() {
      let that = this;
      console.log("currCountryId", that.currCountryId);
      if (that.currCountryId == 242) {
        // 中国
        that.showAddressItem = true;
      } else {
        that.showAddressItem = false;
        // 省
        that.addShippingAddressInfo.provinceid = "";
        // 市
        that.addShippingAddressInfo.cityid = "";
        // 区
        that.addShippingAddressInfo.areaid = "";
      }
    },

    /**
     * 获取国家列表
     */
    getCountry() {
      let that = this;
      this.$http.getCountry(
        null,
        (res) => {
          that.countryData = res.data;
          that.countryTelData = res.data;
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取省列表
     */
    getProvince() {
      let that = this;
      this.$http.getProvince(
        null,
        (res) => {
          that.provinceData = res.data;
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取市列表
     */
    getCity() {
      let that = this;
      // 清空
      that.cityData = [];
      that.currCityid = "";
      that.AreaData = [];
      that.currAreaId = "";
      let data = {
        code: that.currProvinceId,
      };
      this.$http.getCity(
        data,
        (res) => {
          that.cityData = res.data;
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取区列表
     */
    getArea() {
      let that = this;
      // 清空
      that.AreaData = [];
      that.currAreaId = "";
      let data = {
        code: that.currCityid,
      };
      this.$http.getArea(
        data,
        (res) => {
          that.AreaData = res.data;
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 菜单点击
     * @param {*} index
     */
    clickMenu(index) {
      let that = this;
      that.menuList.forEach((v, i) => {
        v.flag = false;
      });
      let newData = that.menuList[index];
      newData.flag = true;
      that.$set(that.menuList, index, newData);
      that.menuActiveIndex = index;
      that.getDataByMenuIndex(index);
    },

    /**
     * 帖子 - 根据type_id获取类型明显
     * @param {*} id
     */
    getTypeNameById(id) {
      let that = this;
      let typeTitle = "最新发帖";
      switch (parseInt(id)) {
        case 0:
          this.currLanguage == 3
            ? (typeTitle = "Latest Posts")
            : (typeTitle = "最新发帖");
          break;
        case 1:
          this.currLanguage == 3
            ? (typeTitle = "Problem feedback")
            : (typeTitle = "问题反馈");
          break;
        case 2:
          this.currLanguage == 3
            ? (typeTitle = "Seek help")
            : (typeTitle = "求助");
          break;
        case 3:
          this.currLanguage == 3
            ? (typeTitle = "Latest Posts")
            : (typeTitle = "最新发帖");
          break;

        default:
          this.currLanguage == 3
            ? (typeTitle = "Discuss")
            : (typeTitle = "讨论");
          break;
      }
      return typeTitle;
    },

    /**
     * 根据菜单点击- 获取数据
     * @param {*} index
     */
    getDataByMenuIndex(index) {
      let that = this;
      // 分页数据清空
      that.page = 1;
      that.pagesize = 10;
      that.pageCount = 1;

      switch (index) {
        case 0:
          // 我的订单
          that.getUserOrderList();
          // that.getUserOrderCount();
          break;
        case 1:
          // 我的评论
          that.getUserProductCommentList();
          break;
        case 2:
          // 我的收藏
          that.getUserProductCollectList();
          break;
        case 3:
          // 优惠券
          that.getUserCoupon();
          break;
        case 4:
          // 收货地址
          that.getAddressList();
          // 获取国家列表
          that.getCountry();
          // 获取省列表
          that.getProvince();
          break;
        case 5:
          // 我的帖子
          that.getUserBlog();
          break;
        case 6:
          // 个人信息
          that.getUserInfo();
          // 获取国家列表
          that.getCountry();
          break;

        default:
          break;
      }
    },
    /**
     * 待评价产品  点击评价 组合数组 portfolio_sales_data 单品 product_data
     */
    appraiseProductHandler(order_id, list, product_data_list) {
      this.showOrder = false;
      this.order_id = order_id;
      this.appraiseProduct = list;
      this.appraiseoneProduct = product_data_list;
      if (this.appraiseProduct.length > 0) {
        this.appraiseProduct.forEach((v, i) => {
          v.forEach((item) => {
            item.appraiseImgList = [];
            item.star = 0;
            item.appraiseText = "";
          });
        });
      }

      if (this.appraiseoneProduct.length > 0) {
        this.appraiseoneProduct.forEach((v, i) => {
          v.appraiseImgList = [];
          v.star = 0;
          v.appraiseText = "";
        });
      }
      // console.log("obj", order_id, list);
    },
    /**
     * 评价星级 组合商品
     */
    onStarChange(i, proIndex) {
      console.log("statNum", i, proIndex);
      this.$set(
        this.appraiseProduct[i],
        proIndex,
        this.appraiseProduct[i][proIndex]
      );
    },
    /**
     * 评价星级 单个商品
     */
    onfirstStarChange(proIndex) {
      this.$set(
        this.appraiseoneProduct,
        proIndex,
        this.appraiseoneProduct[proIndex]
      );
    },

    /**
     * input变化
     */
    inputValue(e) {
      // this.$forceUpdate();
      this.$set(
        this.appraiseProduct[this.inputSelectedIndexs[0]],
        this.inputSelectedIndexs[1],
        this.appraiseProduct[this.inputSelectedIndexs[0]][
          this.inputSelectedIndexs[1]
        ]
      );
    },

    /**
     * 存储选中的索引值
     */
    firstinputSelectedIndex(proIndex) {
      this.proIndex = proIndex;
    },
    /**
     * input变化
     */
    firstinputValue(e) {
      // this.$forceUpdate();
      this.$set(
        this.appraiseoneProduct,
        this.proIndex,
        this.appraiseoneProduct[this.proIndex]
      );
    },

    /**
     * 存储选中的索引值
     */
    inputSelectedIndex(firstIndex, secondIndex) {
      this.inputSelectedIndexs = [firstIndex, secondIndex];
    },
    /**
     * 提交评价
     */
    appraisProductContentList() {
      let appraise_data = [];
      console.log("this.appraiseProduct", this.appraiseProduct);

      this.appraiseProduct.forEach((item) => {
        item.forEach((v) => {
          appraise_data.push({
            order_id: this.order_id,
            product_id: v.id,
            sku_number: v.number,
            star: v.star,
            comment: v.appraiseText,
            // pics: JSON.stringify(v.appraiseImgList),
            pics: v.appraiseImgList.join(),
            // pics: "",
          });
        });
      });
      this.appraiseoneProduct.forEach((v) => {
        appraise_data.push({
          order_id: this.order_id,
          product_id: v.id,
          sku_number: v.number,
          star: v.star,
          comment: v.appraiseText,
          // pics: JSON.stringify(v.appraiseImgList),
          pics: v.appraiseImgList.join(),
        });
      });
      console.log("this.appraiseProduct", appraise_data);
      let data = {
        appraise_data: appraise_data,
      };
      this.$http.appraises(
        data,
        (res) => {
          console.log(res);
          if (res.ret == 1) {
            this.$message.success(res.msg);
            this.showOrder = true;
            this.order_status = 5;
            this.getUserOrderList();
          }
        },
        (res) => {
          // this.$message.error(res.msg);
          this.$message.warning("请完善当前评价信息！");
        }
      );
    },
    /**
     * 取消评价
     */
    cancelApprais() {
      this.showOrder = true;
    },
    /**
     * 我的订单列表
     */
    getUserOrderList() {
      let that = this;
      //loading
      that.orderListloading = true;
      let data = {
        page: that.page,
        pagesize: that.pagesize,
        order_status: that.order_status, //0全部1待支付3待发货4待收货5待评价7已完成
        key: that.searchKey, //订单编号-搜索框
        exchange_rate: localStorage.getItem("currencyRate"), //汇率值
      };
      this.$http.getUserOrderList(
        data,
        (res) => {
          if (res.ret == 1) {
            // 订单列表数据
            that.orderList = res.data;
            //loading
            that.orderListloading = false;
            if (
              that.orderList.length > 0 &&
              this.currLanguage != 3 &&
              this.currLanguage != 1
            ) {
              that.languageTranslateByArrs(that.orderList, 2);
            }
            // 分页-总数
            that.pageCount = parseInt(res.total);
            // 设置我的订单title的数量标
          } else {
            that.orderListloading = false;
            that.orderList = [];
            this.$message.error(res.msg);
          }
        },
        (res) => {
          that.orderListloading = false;
          that.orderList = [];
          // this.$message.error(res.msg);
        }
      );
    },
    /**
     * 我的订单统计
     */
    getUserOrderCount() {
      let that = this;
      let data = {};
      this.$http.getUserOrderCount(
        data,
        (res) => {
          if (res.ret == 1) {
            // 设置我的订单title的数量标
            that.setMyOrderTitleNum(res);
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          // that.orderList = [];
          // this.$message.error(res.msg);
        }
      );
    },
    /**
     * 设置我的订单title的数量标
     */
    setMyOrderTitleNum(res) {
      // wait_receive_num	int	待收货量
      let that = this;
      let titleData1 = that.orderMenu[1]; //待支付
      let titleData2 = that.orderMenu[2]; //待发货
      let titleData3 = that.orderMenu[3]; //待收货
      let titleData4 = that.orderMenu[4]; //待评价
      let titleData5 = that.orderMenu[5]; //已完成

      titleData1.num = parseInt(res.wait_pay_num); //待支付
      titleData2.num = parseInt(res.wait_send_num); //待发货
      titleData3.num = parseInt(res.wait_receive_num); //待收货
      titleData4.num = parseInt(res.wait_comment_num); //待评价
      titleData5.num = parseInt(res.finish_num); //已完成

      that.$set(that.orderMenu, 1, titleData1); //待支付
      that.$set(that.orderMenu, 2, titleData2); //待发货
      that.$set(that.orderMenu, 3, titleData3); //待收货
      that.$set(that.orderMenu, 4, titleData4); //待评价
      that.$set(that.orderMenu, 5, titleData5); //已完成
    },

    /**
     * 删除订单
     */
    deleteUserOrder(order_id) {
      let that = this;
      let data = {
        order_id: order_id, //订单id
      };
      this.$http.deleteUserOrder(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(res.msg);
            // 刷新我的订单
            that.getUserOrderList();
            that.getUserOrderCount();
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     *  订单-取消订单-确认收货
     */
    dealOrder(order_id, status) {
      let that = this;
      let data = {
        order_id: order_id, //订单id
        status: status, //状态 -1取消 5确认收货
      };
      this.$http.dealOrder(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(that.pageTextArr[32]);
            // 刷新我的订单
            that.getUserOrderList();
            that.getUserOrderCount();
          } else {
            this.$message.error(that.pageTextArr[33]);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },
    /**
     * 点击订单的菜单
     * @param {*} index 0全部1待支付3待发货4待收货5待评价7已完成
     */
    orderMenuClick(index, activeIndex) {
      let that = this;
      that.orderMenuActive = activeIndex;
      switch (index) {
        //全部
        case 0:
          that.order_status = 0;
          break;
        // 待支付
        case 1:
          that.order_status = 1;
          break;
        // 待发货
        case 2:
          that.order_status = 3;
          break;
        // 待评价
        case 3:
          that.order_status = 5;
          break;
        // 已完成
        case 4:
          that.order_status = 7;
          break;
        // 待收货
        case 5:
          that.order_status = 4;
          break;

        default:
          break;
      }
      // console.log("index", index, 'that.order_status', that.order_status);
      // 我的订单
      that.getUserOrderList();
      // that.getUserOrderCount();
    },

    /**
     * 我的订单--headerbar点击
     * @param {*} index
     */
    clickEvaluateHeaderBar(index) {
      let that = this;
      that.evaluateHeaderBar.activeBar = index;
      if (index == 0) {
        // 评价
        that.getUserProductCommentList();
      } else {
        // 博客
        that.getMyCommentBlogList();
      }
    },

    /**
     * 我的评论列表
     */
    getUserProductCommentList() {
      let that = this;
      let data = {
        page: that.page,
        pagesize: that.pagesize,
      };
      this.$http.userProductComment(
        data,
        (res) => {
          if (res.ret == 1) {
            that.evaluateData = res.data;
            if (that.evaluateData && this.currLanguage != 1) {
              that.languageTranslateByArrs(that.evaluateData, 3);
            }
            that.pageCount = parseInt(res.total);
          } else {
            that.evaluateData = [];
            this.$message.error(res.msg);
          }
        },
        (res) => {
          that.evaluateData = [];
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 我的评论列表-博客
     */
    getMyCommentBlogList() {
      let that = this;
      let data = {
        page: that.page,
        pagesize: that.pagesize,
      };
      this.$http.myCommentBlog(
        data,
        (res) => {
          if (res.ret == 1) {
            that.blogListData = res.data;
            that.pageCount = parseInt(res.total);
          } else {
            that.blogListData = [];
            this.$message.error(res.msg);
          }
        },
        (res) => {
          that.blogListData = [];
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 我的收藏列表
     */
    getUserProductCollectList() {
      let that = this;
      let data = {
        page: that.page,
        pagesize: that.pagesize,
        searchkey: that.collectionSearchKey, //搜索
        exchange_rate: localStorage.getItem("currencyRate"), //汇率值
        exchange_rate_id: localStorage.getItem("exchangeRateId"), //(汇率id)
        exchange_rate_symbol: localStorage.getItem("currencySymbol"),
      };
      this.$http.userProductCollect(
        data,
        (res) => {
          if (res.ret == 1) {
            that.ProductCollectList = res.data;
            if (
              that.ProductCollectList.length > 0 &&
              this.currLanguage != 3 &&
              this.currLanguage != 1
            ) {
              that.languageTranslateByArrs(that.ProductCollectList, 4);
            }

            // that.currencySymbol = res.currencySymbol;
          } else {
            that.ProductCollectList = [];
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          that.ProductCollectList = [];
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 商品加入购物车
     * @param {*} product_id
     * @param {*} sku_number
     * @param {*} type
     * @param {*} portfolio_sales_middle_id
     * @param {*} cartNum
     */
    productAddCart(
      product_id,
      sku_number,
      type,
      portfolio_sales_middle_id,
      cartNum
    ) {
      let that = this;
      that.$parent.addCart(
        product_id,
        sku_number,
        type,
        portfolio_sales_middle_id,
        cartNum
      );
    },

    /**
     * 个人优惠券列表
     */
    getUserCoupon() {
      let that = this;
      let data = {
        page: that.page,
        pagesize: that.pagesize,
        is_use: that.coupon_is_use, //1未使用2已使用
        exchange_rate: localStorage.getItem("currencyRate"), //汇率值
        time_status: that.coupon_time_status, //1未过期2已过期 未使用
      };
      this.$http.getUserCoupon(
        data,
        (res) => {
          if (res.ret == 1) {
            that.showCouponDetailData = res.data;
            //
            that.setCpuponListTiTleNum(res);
            // 分页-总数
            that.pageCount = parseInt(res.total);
            //
            // that.currencySymbol = res.currencySymbol;
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 设置优惠券title的数量
     */
    setCpuponListTiTleNum(res) {
      let that = this;
      let useData = that.couponHeaderBar.barList[0]; //可用
      let noUseData = that.couponHeaderBar.barList[1]; //已用
      let outTimeData = that.couponHeaderBar.barList[2]; //过期
      useData.num = parseInt(res.use_total);
      noUseData.num = parseInt(res.no_use_total);
      outTimeData.num = parseInt(res.out_time_total);

      that.$set(that.couponHeaderBar.barList, 0, useData);
      that.$set(that.couponHeaderBar.barList, 1, noUseData);
      that.$set(that.couponHeaderBar.barList, 2, outTimeData);
    },

    /**
     * 优惠券 -headerbar点击
     * @param {*} index
     */
    clickcoupoHeaderBar(index) {
      let that = this;
      that.couponHeaderBar.activeBar = index;
      if (index == 0) {
        // 可用
        // 未使用
        that.coupon_is_use = 1;
        // 未过期
        that.coupon_time_status = 1;
      } else if (index == 1) {
        // 已用
        // 已使用
        that.coupon_is_use = 2;
        // 未过期
        that.coupon_time_status = 1;
      } else if (index == 2) {
        // 过期
        // 未使用
        that.coupon_is_use = 1;
        // 未过期
        that.coupon_time_status = 2;
      }
      // 优惠券列表
      that.getUserCoupon();
    },
    /**
     * 优惠券立即使用-跳转优惠劵商品页面
     */
    couponUseNow() {
      this.$router.push({
        path: "/commodityCoupon",
        // query: { name: "", age: "" },
      });
    },

    /**
     * 调转等待付款页面
     * @param {*} order_number
     */
    toPayment(order_number, id) {
      this.$router.push({
        path: "/waitingPayment",
        query: { order_number: order_number, page_status: 1, order_id: id },
      });
    },

    /**
     * 判断是手机还是PC 1-手机，0-PC
     */
    getEquipmentType() {
      let that = this;
      that.equipmentType = localStorage.getItem("equipmentType");
      if (that.equipmentType == 0) {
        that.showAddaddressDialogWidth = "900px";
      } else {
        that.showAddaddressDialogWidth = "95%";
      }
    },

    /**
     * 查看物流信息
     */
    showlogistics() {
      let that = this;
      that.showLogistics = true;
    },

    /**
     * 星星数量
     * @param {*} startNum
     */
    getsStarScalculation(startNum) {
      // console.log('startNum',startNum);
      let num = {
        starsFlag0: 0,
        starsFlag1: 0,
        starsFlag2: 0,
      };
      let that = this;
      // 向下取证获取完成的星星数量
      num.starsFlag1 = Math.floor(startNum);
      // 获取半个星星的数量
      num.starsFlag0 = Math.ceil(startNum - Math.floor(startNum));
      // 5减去向上取整获取空的星星数量
      num.starsFlag2 = 5 - Math.ceil(startNum);
      return num;
    },

    /**
     * 收货地址列表
     */
    getAddressList() {
      let that = this;
      this.$http.addressList(
        null,
        (res) => {
          that.shippingAddressList = res.data;
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 编辑收货地址
     */
    editAddress() {
      let that = this;
      // 0-添加，1-编辑
      // console.log('addressEditStauts', that.addressEditStauts);
      if (that.addressEditStauts == 0) {
        that.addAddress();
      } else {
        that.updateAddress();
      }
    },

    /**
     * 添加收货地址
     */
    addAddress() {
      let that = this;

      // 国家
      that.addShippingAddressInfo.country_id = that.currCountryId;
      // 省
      that.addShippingAddressInfo.provinceid = that.currProvinceId;
      // 市
      that.addShippingAddressInfo.cityid = that.currCityid;
      // 区
      that.addShippingAddressInfo.areaid = that.currAreaId;
      that.addShippingAddressInfo.is_default = 0;
      that.addShippingAddressInfo.address2 = "";

      var re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
      if(!re.test(that.addShippingAddressInfo.email)){
        this.$message.error("邮箱不合法！");
        return
      }
      let data = that.addShippingAddressInfo;
      this.$http.addAddress(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(res.msg);
            // 收货地址
            that.getAddressList();
            that.showAddaddressDialog = false;
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          this.$message.error(res.msg);
        }
      );
    },

    /**
     * 收货地址-设为默认
     * @param {*} addressId
     */
    shippingDefault(addressId) {
      let that = this;
      that.setDefault(addressId);
    },

    /**
     * 修改收货地址
     */
    updateAddress() {
      let that = this;
      console.log("that.currCountryId", that.currCountryId);
      if (that.currCountryId == 242) {
        // 中国
        that.showAddressItem = true;
      }
      // 国家
      that.addShippingAddressInfo.country_id = that.currCountryId;
      // 省
      that.addShippingAddressInfo.provinceid = that.currProvinceId;
      // 市
      that.addShippingAddressInfo.cityid = that.currCityid;
      // 区
      that.addShippingAddressInfo.areaid = that.currAreaId;
      that.addShippingAddressInfo.address_id = that.addShippingAddressInfo.id;
      that.addShippingAddressInfo.is_default =
        that.addShippingAddressInfo.default;
      that.addShippingAddressInfo.address2 = "";
      let data = that.addShippingAddressInfo;
      // console.log('data--', data);
      this.$http.updateAddress(
        data,
        (res) => {
          // 收货地址
          that.getAddressList();
          that.showAddaddressDialog = false;
        },
        (res) => {
          this.$message.error(res.msg);
        }
      );
    },

    /**
     * 设置默认地址
     * @param {*} addressId
     */
    setDefault(addressId) {
      let that = this;
      let data = {
        address_id: addressId,
        is_default: 1,
      };
      this.$http.setDefault(
        data,
        (res) => {
          if (res.ret == 1) {
            // 收货地址
            that.getAddressList();
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 收货地址-编辑
     * @param {*} index
     */
    shippingEdit(index) {
      let that = this;
      that.showAddaddressTitle = this.pageTextArr[95];

      that.addressEditStauts = 1;
      that.addShippingAddressInfo = that.shippingAddressList[index];
      console.log("addShippingAddressInfo", that.addShippingAddressInfo);
      // 国家
      that.currCountryId = that.addShippingAddressInfo.country_id;
      // 省
      that.currProvinceId = that.addShippingAddressInfo.provinceid;
      if (that.currCountryId == 242) {
        that.showAddressItem = true;
      }
      setTimeout(() => {
        // 市
        that.getCity();
        that.currCityid = that.addShippingAddressInfo.cityid;
      }, 300);
      setTimeout(() => {
        // 区
        that.getArea();
        that.currAreaId = that.addShippingAddressInfo.areaid;
        that.showAddaddressDialog = true;
      }, 600);
    },

    /**
     * 收货地址查看更多
     */
    viewMoreAddress() {
      let that = this;
      that.addressShowLength = that.shippingAddressList.length;
    },

    /**
     * 新增收货地址弹窗
     */
    showAddressDialog() {
      let that = this;
      that.showAddaddressTitle = this.pageTextArr[51];

      that.showAddaddressDialog = true;
      that.addressEditStauts = 0;
      // 清空
      that.addShippingAddressInfo = {};
      that.currCountryId = "";
      that.currProvinceId = "";
      that.currCityid = "";
      that.currAreaId = "";
      // 设置默认国家
      if (localStorage.getItem("curLanguage") == "简体中文") {
        that.currCountryId = "242"; //中国
        that.showAddressItem = true;
      } else {
        that.currCountryId = "135"; //美国
      }
    },

    /**
     * 删除收货地址
     * @param {*} addressId
     */
    deleteAddress(addressId) {
      let that = this;
      let data = {
        address_id: addressId,
      };
      this.$http.deleteAddress(
        data,
        (res) => {
          if (res.ret == 1) {
            // 收货地址
            that.getAddressList();
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 我的帖子
     */
    getUserBlog() {
      let that = this;
      let data = {
        // type_id: 0,
        page: that.page,
        pagesize: that.pagesize,
      };
      this.$http.getUserBlog(
        data,
        (res) => {
          if (res.ret == 1) {
            that.postData = res.data;
            that.pageCount = parseInt(res.pagesize);
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 我回复的
     */
    myComment() {
      let that = this;
      let data = {
        page: that.page,
        pagesize: that.pagesize,
      };
      this.$http.myComment(
        data,
        (res) => {
          if (res.ret == 1) {
            that.postreplyData = res.data;
            that.pageCount = parseInt(res.pagesize);
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 地区
     * @param {*} value
     */
    handleChange(value) {
      console.log(value);
    },

    /**
     * 我的帖子-菜单点击
     * @param {*} index
     */
    clickPostHeaderBar(index) {
      let that = this;
      that.postHeaderBar.activeBar = index;
      if (index == 0) {
        // 我的帖子
        that.getUserBlog();
      } else {
        // 重置分页数据
        that.page = 1;
        that.pagesize = 10;
        // 我的回复
        that.myComment();
      }
    },

    /**
     * 个人中心-菜单点击
     * @param {*} index
     */
    clickUserHeaderBar(index) {
      this.userHeaderBar.activeBar = index;
    },

    /**
     * 修改头像弹窗
     */
    editFaceDialog() {
      this.showeditFace = true;
      this.imgFileList = [];
    },
    /**
     * 关闭弹窗
     */
    closeDialog() {
      this.oldphoneVerification = false;
      this.editnewPhone = false;
      this.newphoneVerification = false;
    },
    /**
     * 更换手机号
     */
    replacePhoneDialog() {
      this.editoldPhoneDialog = true;
      this.editoldEmailDialog = false;
      this.editoldPhone = true;
      this.oldPhone = "";
      this.verificationcode = "";
      this.checkEmial = "";
      this.phonePrefix = "";
      console.log("this.editoldEmailDialog ", this.editoldEmailDialog);
    },

    /**
     * 邮箱验证
     */
    tophoneVerification() {
      let that = this;
      if (that.checkEmial != "" && !this.editoldEmailDialog) {
        that.sendUpdateMobileEmail();
      } else if (that.checkEmial == "" && !this.editoldEmailDialog) {
        this.$message.warning("请填写手机号码！");
      } else if (that.checkEmial != "" && this.editoldEmailDialog) {
        that.sendUpdateMobileEmail();
      } else if (that.checkEmial == "" && this.editoldEmailDialog) {
        this.$message.warning("请填写邮箱地址！");
      }
    },

    /**
     * 发送修改手机号验证码邮件
     */
    sendUpdateMobileEmail() {
      let that = this;
      let data = {
        email: that.checkEmial,
      };
      this.$http.sendUpdateMobileEmail(
        data,
        (res) => {
          this.$message.success(res.msg);
          this.editoldPhone = false;
          this.oldphoneVerification = true;
        },
        (res) => {
          this.$message.error(res.msg);
        }
      );
    },

    /**
     * 验证邮箱验证码
     */
    checkEmailCode() {
      let that = this;
      let data = {
        email: that.checkEmial,
        code: that.verificationcode,
      };
      this.$http.checkEmailCode(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(res.msg);
            that.oldphoneVerification = false;
            that.editnewPhone = true;
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 修改手机号
     */
     updateEmail() {
      let that = this;
      let data = {
        email: that.newMobile,
        // mobile: that.newMobile,
      };
      this.$http.updateEmail(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(res.msg);
            that.editnewPhone = false;
            that.newphoneVerification = false;
            that.editoldPhoneDialog = false;
            that.checkEmial = "";
            that.newMobile = ""
            // 个人信息
            that.getUserInfo();
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },
    // // 修改手机号-4
    // tonewPhoneSure() {
    //   this.newphoneVerification = false;
    //   this.editoldPhoneDialog = false;
    //   this.verificationcode = "";
    // },

    /**
     * 更换邮箱
     */
    replaceEmailDialog() {
      this.editoldPhoneDialog = true;
      this.editoldEmailDialog = true;
      this.editoldPhone = true;
      this.phonePrefix = "";
      this.checkEmial = "";
      this.verificationcode = "";
    },
    selectNation() {
      this.selectNationDialog = true;
    },
    tonationSure() {
      this.selectNationDialog = false;
    },
    selectNationTitle(index) {
      this.nationTitle = index;
    },

    /**
     * 国家选择弹窗-open
     */
    selectNation() {
      this.selectNationDialog = true;
    },

    /**
     * 国家选择弹窗-close
     */
    tonationSure() {
      this.userInfoForm.country = this.currCountryName;
      this.selectNationDialog = false;
    },
    selectNationTitle(index) {
      this.nationTitle = index;
    },

    /**
     * 跳转商品详情
     * @param {*} id
     */
    toProductDetail(id) {
      this.$router.push({
        path: "/productDetail",
        query: { product_id: id },
      });
    },

    /**
     * 跳转博客详情
     */
    toBolgDeatil(id) {
      this.$router.push({
        path: "/bolgDeatil",
        query: { name: this.tabActiveLable, uuid: id },
      });
    },

    /**
     * 论坛详情
     */
    toForumDetail(id) {
      this.$router.push({
        path: "/forumDetail",
        query: { name: "", age: "", uuid: id },
      });
    },

    /**
     * 国家选择确认点击
     * @param {*} countryId
     * @param {*} countryName
     */
    selectCpuntry(countryId, countryName) {
      let that = this;
      that.currCountryId = countryId;
      that.currCountryName = countryName;
      // console.log("currCountryId", that.currCountryId);
      // console.log("currCountryName", that.currCountryName);
    },

    /**
     * 获取用户信息
     */
    getUserInfo() {
      let that = this;
      this.$http.getUserInfo(
        null,
        (res) => {
          if (res.ret == 1) {
            that.userInfoForm = res.data;
            that.uoloadSuccessImgUrl = res.data.head_img;
            that.userInfoForm.userName = res.data.surname + res.data.name;
            if (res.data.birth_date) {
              that.userInfoForm.year = res.data.birth_date.split("-")[0];
              that.userInfoForm.month = res.data.birth_date.split("-")[0];
              that.userInfoForm.day = res.data.birth_date.split("-")[0];
            }
            if(that.userInfoForm.country =="中国"){
              that.currTel = "+86"
            }
            this.$parent.updateUserInfo();
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 编辑用户信息
     */
    updateUserInfo() {
      let that = this;
      let data = {
        head_img: that.userInfoForm.head_img,
        surname: that.userInfoForm.userName.slice(0, 1),
        name: that.userInfoForm.userName.slice(1),
        sex: that.userInfoForm.sex,
        mobile: that.userInfoForm.mobile,
        email: that.userInfoForm.email,
        country_id: that.currCountryId,
        company: that.userInfoForm.company,
        birth_date:
          that.userInfoForm.year +
          "-" +
          that.userInfoForm.month +
          "-" +
          that.userInfoForm.day,
      };

      // return
      this.$http.updateUserInfo(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(res.msg);
            // 重新获取信息
            that.getUserInfo();
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 判断文件上传数量
     * @param {*} files
     * @param {*} fileList
     */
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件，请先删除已存在的文件`
      );
    },

    /**
     * 上传文件前判断
     * @param {*} file
     */
    beforeFileUpload(file) {
      console.log("FILE", file);
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传文件只能是JPG格式!");
        this.fileList = [];
      }
      if (!isLt2M) {
        this.$message.error("上传xlsx表格文件且不能超过 5MB!");
        this.fileList = [];
      }
      return isJPG && isLt2M;
    },
    /**
     * 上传完成之后
     * @param {*} res
     * @param {*} file
     */
    uploadappraiseImgSeccess(res, file) {
      let that = this;
      console.log("res", res);
      if (res.ret == 1) {
        // that.uploadImgData.push(res.data.file_url);
        // console.log("res", that.uploadImgData);
        // that.$forceUpdate()
        if (this.type == 2) {
          this.appraiseProduct[this.proFileIndex[0]][
            this.proFileIndex[1]
          ].appraiseImgList.push(res.data.file_url);
          this.$set(
            this.appraiseProduct[this.proFileIndex[0]],
            this.proFileIndex[1],
            this.appraiseProduct[this.proFileIndex[0]][this.proFileIndex[1]]
          );
        } else {
          this.appraiseoneProduct[this.proFileIndex[0]].appraiseImgList.push(
            res.data.file_url
          );
          this.$set(
            this.appraiseoneProduct,
            this.proFileIndex[0],
            this.appraiseoneProduct[this.proFileIndex[0]]
          );
        }
      } else {
        that.$message({ title: "警告", message: res.msg, type: "error" });
      }
    },
    uploadImgList(i, proIndex, type) {
      console.log("proIndex,index", i, proIndex);
      this.proFileIndex = [i, proIndex];
      this.type = type;
    },
    deleteImg(list, index) {
      console.log("list,index", list, index);
      // list.split(index,1)
      list.splice(index, 1);
      if (this.type == 2) {
        this.$set(
          this.appraiseProduct[this.proFileIndex[0]],
          this.proFileIndex[1],
          this.appraiseProduct[this.proFileIndex[0]][this.proFileIndex[1]]
        );
      } else {
        this.$set(
          this.appraiseoneProduct,
          this.proFileIndex[0],
          this.appraiseoneProduct[this.proFileIndex[0]]
        );
      }
    },

    /**
     * 上传完成之后
     * @param {*} res
     * @param {*} file
     */
    uploadImgSeccess(res, file) {
      let that = this;
      console.log("res", res);
      if (res.ret == 1) {
        // this.loginInfoData.face = res.data;
        that.uoloadSuccessImgUrl = res.data.file_url;
      } else {
        that.$message({ title: "警告", message: res.msg, type: "error" });
      }
    },

    /**
     * 保存上传图片
     */
    saveUserInfoFace() {
      let that = this;
      that.userInfoForm.head_img = that.uoloadSuccessImgUrl;
      this.showeditFace = false;
    },

    /**
     * 确认保存
     */
    confirmSave() {
      let that = this;
      if (
        that.formEditPassword.newPassword != that.formEditPassword.surePassword
      ) {
        this.$message({
          title: "警告",
          message: "请确认新密码与确认密码保持一致！",
          type: "error",
        });
      } else {
        that.updatePassword();
      }
    },

    /**
     * 修改密码
     */
    updatePassword() {
      let that = this;
      let data = {
        old_password: that.formEditPassword.oldPassword,
        new_password: that.formEditPassword.newPassword,
        confirm_password: that.formEditPassword.surePassword,
      };

      this.$http.updatePassword(
        data,
        (res) => {
          if (res.ret == 1) {
            this.$message.success(res.msg);
            // 重新获取信息
            that.getUserInfo();
            that.userInfoForm = res.data;
            that.userInfoForm.userName = res.data.surname + res.data.name;
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 跳转对应数据
     */
    toEditUsrtInfo(index) {
      let that = this;

      that.menuActiveIndex = index;
      // 更改菜单-list 选中的
      that.menuList.forEach((item) => {
        item.flag = false;
      });
      let newData = that.menuList[index];
      newData.flag = true;
      that.$set(that.menuList, index, newData);
    },

    /**
     * 取消收藏
     */
    productaddCollect(id, type, index) {
      let that = this;
      that.$parent.productCollect(
        id,
        type,
        (res) => {
          if (res.ret == 1) {
            // 刷新我的收藏列表
            that.getUserProductCollectList();
            this.$message.success(res.msg);
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取url参数
     */
    getUrlData() {
      let that = this;
      let index = that.$route.query.index;
      let pageStatus = that.$route.query.pageStatus;
      if (pageStatus == 1) {
        that.toEditUsrtInfo(index);
        that.getDataByMenuIndex(parseInt(index));
      }
    },

    /**
     * 国际化翻译
     */
    vueInternationalTranslation() {
      this.showAddaddressTitle = this.pageTextArr[95];
      this.currencySymbol = localStorage.getItem("currencySymbol");
      console.log(this.currencySymbol, 4348);
      // 我的订单
      this.menuList[0].title = this.pageTextArr[2];
      // 我的评论
      this.menuList[1].title = this.pageTextArr[3];
      // 我的收藏
      this.menuList[2].title = this.pageTextArr[4];
      // 优惠券
      this.menuList[3].title = this.pageTextArr[5];
      // 收货地址
      this.menuList[4].title = this.pageTextArr[6];
      // 我的贴子
      this.menuList[5].title = this.pageTextArr[7];
      // 个人信息
      this.menuList[6].title = this.pageTextArr[8];

      // 全部订单
      this.orderMenu[0].title = this.pageTextArr[9];
      // 待支付
      this.orderMenu[1].title = this.pageTextArr[10];
      // 待发货
      this.orderMenu[2].title = this.pageTextArr[11];
      // 待收货
      this.orderMenu[3].title = this.pageTextArr[12];
      // 待评价
      this.orderMenu[4].title = this.pageTextArr[13];
      // 已完成
      this.orderMenu[5].title = this.pageTextArr[14];

      //
      this.evaluateHeaderBar.barList[0].title = this.pageTextArr[38];
      this.evaluateHeaderBar.barList[1].title = this.pageTextArr[39];
      this.couponHeaderBar.barList[0].title = this.pageTextArr[44];
      this.couponHeaderBar.barList[1].title = this.pageTextArr[45];
      this.couponHeaderBar.barList[2].title = this.pageTextArr[46];

      this.postHeaderBar.barList[0].title = this.pageTextArr[63];
      this.postHeaderBar.barList[1].title = this.pageTextArr[64];

      this.userHeaderBar.barList[0].title = this.pageTextArr[65];
      this.userHeaderBar.barList[1].title = this.pageTextArr[66];
    },

    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr, type) {
      let that = this;
      let newpagetextArr = [];
      if (type == 1) {
        that.translateByArr(arr, (res) => {
          res.data.forEach((item, index) => {
            newpagetextArr.push(item.translation);
          });
          that.pageTextArr = newpagetextArr;
          that.vueInternationalTranslation();
        });
      } else if (type == 2) {
        let pro = [];
        let sku = [];
        let pros = [];
        let skus = [];
        arr.forEach((item, index) => {
          if (arr[index].product_data.length > 0) {
            arr[index].product_data.forEach((item1, index1) => {
              pro.push(index + "@" + index1 + "@" + item1.title);
              sku.push(index + "@" + index1 + "@" + item1.specifications);
            });
          }
          if (arr[index].portfolio_sales_data.length > 0) {
            arr[index].portfolio_sales_data[0].forEach((item2, index2) => {
              pros.push(index + "@" + index2 + "@" + item2.title);
              skus.push(index + "@" + index2 + "@" + item2.specifications);
            });
          }
        });

        if (pro.length > 0) {
          that.translateByArr(pro, (res) => {
            res.data.forEach((v, i) => {
              let index = v.query.split("@")[0];
              let childIndex = v.query.split("@")[1];
              that.orderList[index].product_data[childIndex].title =
                v.translation.split("@")[2];
            });
          });
        }
        if (sku.length > 0) {
          that.translateByArr(sku, (res) => {
            res.data.forEach((v, i) => {
              let index = v.query.split("@")[0];
              let childIndex = v.query.split("@")[1];
              that.orderList[index].product_data[childIndex].specifications =
                v.translation.split("@")[2];
            });
          });
        }
        if (pros.length > 0) {
          that.translateByArr(pros, (res) => {
            res.data.forEach((v, i) => {
              let index = v.query.split("@")[0];
              let childIndex = v.query.split("@")[1];
              that.orderList[index].portfolio_sales_data[0][childIndex].title =
                v.translation.split("@")[2];
            });
          });
        }
        if (skus.length > 0) {
          that.translateByArr(skus, (res) => {
            res.data.forEach((v, i) => {
              let index = v.query.split("@")[0];
              let childIndex = v.query.split("@")[1];
              that.orderList[index].portfolio_sales_data[0][
                childIndex
              ].specifications = v.translation.split("@")[2];
            });
          });
        }
      } else if (type == 4) {
        let newarr = [];
        arr.forEach((item, index) => {
          newarr.push(item.title);
        });
        that.translateByArr(newarr, (res) => {
          res.data.forEach((item, index) => {
            that.ProductCollectList[index].title = item.translation;
          });
        });
      } else {
        let newarr = [];
        let skuarr = [];
        let comment = [];
        arr.forEach((item, index) => {
          newarr.push(item.title);
          skuarr.push(item.spe);
          comment.push(item.comment);
        });
        that.translateByArr(newarr, (res) => {
          res.data.forEach((item, index) => {
            that.evaluateData[index].title = item.translation;
          });
        });
        that.translateByArr(skuarr, (res) => {
          res.data.forEach((item, index) => {
            that.evaluateData[index].spe = item.translation;
          });
        });
        that.translateByArr(comment, (res) => {
          res.data.forEach((item, index) => {
            that.evaluateData[index].comment = item.translation;
          });
        });
      }
    },
    getMobile(tel) {
      if (tel) {
        const reg = /^(\d{3})\d{4}(\d{4})$/;
        return tel.replace(reg, "$1****$2");
      }
    },
    getEmail(email) {
      if (email) {
        const arr = email.split("@");
        return email.substring(0, arr[0].length - 4) + "****" + "@" + arr[1];
      }
    },
  },
  mounted() {
    let that = this;
    // 当前语言
    that.currLanguage = localStorage.getItem("curLanguageType");
    // 判断是手机还是PC 1-手机，0-PC
    that.getEquipmentType();
    // 个人信息
    that.getUserInfo();
    // 我的订单
    that.getUserOrderList();
    that.getUserOrderCount();
    // url-参数
    that.getUrlData();
    //设置el-upload - header
    this.headerData = {
      accesstoken: localStorage.getItem("token"),
    };
    // 国际化翻译
    that.vueInternationalTranslation();
    that.headerData = {
      accesstoken: localStorage.getItem("token"),
    };
    that.languageTranslateByArrs(that.pageTextArr, 1);
  },
};
</script>


// WEBPACK FOOTER //
// src/view/personalCenterManagement.vue